export default{
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": {
                "adcode": 330702,
                "name": "婺城区",
                "center": [
                    119.652579,
                    29.082607
                ],
                "centroid": [
                    119.509748,
                    28.977012
                ],
                "childrenNum": 0,
                "level": "district",
                "parent": {
                    "adcode": 330700
                },
                "subFeatureIndex": 0,
                "acroutes": [
                    100000,
                    330000,
                    330700
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                119.322977,
                                29.088403
                            ],
                            [
                                119.326009,
                                29.086224
                            ],
                            [
                                119.329554,
                                29.077996
                            ],
                            [
                                119.332524,
                                29.075968
                            ],
                            [
                                119.331825,
                                29.072132
                            ],
                            [
                                119.327828,
                                29.067635
                            ],
                            [
                                119.329072,
                                29.057482
                            ],
                            [
                                119.330907,
                                29.054028
                            ],
                            [
                                119.334281,
                                29.052393
                            ],
                            [
                                119.332384,
                                29.043409
                            ],
                            [
                                119.332742,
                                29.040546
                            ],
                            [
                                119.335136,
                                29.035016
                            ],
                            [
                                119.336645,
                                29.025995
                            ],
                            [
                                119.336272,
                                29.023247
                            ],
                            [
                                119.334701,
                                29.022238
                            ],
                            [
                                119.330596,
                                29.027665
                            ],
                            [
                                119.329881,
                                29.032024
                            ],
                            [
                                119.330192,
                                29.035468
                            ],
                            [
                                119.327346,
                                29.038065
                            ],
                            [
                                119.326336,
                                29.03585
                            ],
                            [
                                119.326444,
                                29.029311
                            ],
                            [
                                119.324858,
                                29.024986
                            ],
                            [
                                119.325372,
                                29.023178
                            ],
                            [
                                119.323894,
                                29.015235
                            ],
                            [
                                119.321624,
                                29.007395
                            ],
                            [
                                119.321515,
                                29.000576
                            ],
                            [
                                119.325092,
                                28.997213
                            ],
                            [
                                119.325714,
                                28.994939
                            ],
                            [
                                119.323304,
                                28.993385
                            ],
                            [
                                119.323599,
                                28.989453
                            ],
                            [
                                119.328544,
                                28.986855
                            ],
                            [
                                119.327642,
                                28.982308
                            ],
                            [
                                119.325916,
                                28.97913
                            ],
                            [
                                119.321344,
                                28.973654
                            ],
                            [
                                119.316633,
                                28.970279
                            ],
                            [
                                119.307879,
                                28.970348
                            ],
                            [
                                119.304613,
                                28.969339
                            ],
                            [
                                119.305655,
                                28.964721
                            ],
                            [
                                119.308516,
                                28.963016
                            ],
                            [
                                119.311486,
                                28.95986
                            ],
                            [
                                119.314021,
                                28.952701
                            ],
                            [
                                119.314985,
                                28.944811
                            ],
                            [
                                119.318359,
                                28.938057
                            ],
                            [
                                119.32265,
                                28.933299
                            ],
                            [
                                119.327144,
                                28.924723
                            ],
                            [
                                119.326818,
                                28.919593
                            ],
                            [
                                119.329274,
                                28.917352
                            ],
                            [
                                119.333784,
                                28.90795
                            ],
                            [
                                119.34019,
                                28.904944
                            ],
                            [
                                119.345461,
                                28.899743
                            ],
                            [
                                119.345492,
                                28.893195
                            ],
                            [
                                119.344497,
                                28.887286
                            ],
                            [
                                119.342336,
                                28.890096
                            ],
                            [
                                119.342538,
                                28.887297
                            ],
                            [
                                119.340563,
                                28.889573
                            ],
                            [
                                119.340283,
                                28.887866
                            ],
                            [
                                119.343782,
                                28.886775
                            ],
                            [
                                119.341045,
                                28.886264
                            ],
                            [
                                119.337842,
                                28.878984
                            ],
                            [
                                119.336256,
                                28.881167
                            ],
                            [
                                119.33156,
                                28.88227
                            ],
                            [
                                119.331793,
                                28.879762
                            ],
                            [
                                119.336272,
                                28.879251
                            ],
                            [
                                119.337407,
                                28.874072
                            ],
                            [
                                119.336303,
                                28.870554
                            ],
                            [
                                119.334934,
                                28.869416
                            ],
                            [
                                119.334919,
                                28.86671
                            ],
                            [
                                119.333613,
                                28.865189
                            ],
                            [
                                119.327704,
                                28.865851
                            ],
                            [
                                119.327144,
                                28.867372
                            ],
                            [
                                119.324501,
                                28.867337
                            ],
                            [
                                119.321453,
                                28.864179
                            ],
                            [
                                119.319681,
                                28.867779
                            ],
                            [
                                119.316648,
                                28.866583
                            ],
                            [
                                119.315296,
                                28.863958
                            ],
                            [
                                119.313057,
                                28.865816
                            ],
                            [
                                119.30962,
                                28.862739
                            ],
                            [
                                119.310553,
                                28.861438
                            ],
                            [
                                119.314238,
                                28.861612
                            ],
                            [
                                119.312046,
                                28.853448
                            ],
                            [
                                119.310895,
                                28.851253
                            ],
                            [
                                119.311315,
                                28.847385
                            ],
                            [
                                119.310273,
                                28.843645
                            ],
                            [
                                119.3113,
                                28.842147
                            ],
                            [
                                119.314409,
                                28.843715
                            ],
                            [
                                119.323832,
                                28.846549
                            ],
                            [
                                119.328217,
                                28.846909
                            ],
                            [
                                119.330954,
                                28.845108
                            ],
                            [
                                119.338029,
                                28.843134
                            ],
                            [
                                119.336629,
                                28.839905
                            ],
                            [
                                119.333737,
                                28.840613
                            ],
                            [
                                119.335945,
                                28.835642
                            ],
                            [
                                119.339164,
                                28.832633
                            ],
                            [
                                119.342818,
                                28.831797
                            ],
                            [
                                119.345554,
                                28.827731
                            ],
                            [
                                119.342802,
                                28.824292
                            ],
                            [
                                119.339335,
                                28.82356
                            ],
                            [
                                119.340019,
                                28.819413
                            ],
                            [
                                119.337142,
                                28.81731
                            ],
                            [
                                119.335479,
                                28.813034
                            ],
                            [
                                119.331514,
                                28.812906
                            ],
                            [
                                119.330363,
                                28.810176
                            ],
                            [
                                119.331622,
                                28.807899
                            ],
                            [
                                119.327004,
                                28.809421
                            ],
                            [
                                119.325232,
                                28.806353
                            ],
                            [
                                119.322511,
                                28.805063
                            ],
                            [
                                119.322417,
                                28.800904
                            ],
                            [
                                119.326227,
                                28.801357
                            ],
                            [
                                119.328621,
                                28.800555
                            ],
                            [
                                119.329212,
                                28.798196
                            ],
                            [
                                119.327004,
                                28.783832
                            ],
                            [
                                119.32772,
                                28.779788
                            ],
                            [
                                119.334126,
                                28.772558
                            ],
                            [
                                119.336225,
                                28.768328
                            ],
                            [
                                119.338433,
                                28.761167
                            ],
                            [
                                119.341807,
                                28.758412
                            ],
                            [
                                119.346239,
                                28.757029
                            ],
                            [
                                119.351028,
                                28.756808
                            ],
                            [
                                119.353329,
                                28.757436
                            ],
                            [
                                119.358211,
                                28.761039
                            ],
                            [
                                119.359875,
                                28.764317
                            ],
                            [
                                119.359549,
                                28.768316
                            ],
                            [
                                119.363265,
                                28.771559
                            ],
                            [
                                119.368738,
                                28.774128
                            ],
                            [
                                119.370387,
                                28.776975
                            ],
                            [
                                119.371895,
                                28.784797
                            ],
                            [
                                119.377928,
                                28.786796
                            ],
                            [
                                119.387677,
                                28.786935
                            ],
                            [
                                119.394223,
                                28.782031
                            ],
                            [
                                119.395918,
                                28.778916
                            ],
                            [
                                119.396229,
                                28.776255
                            ],
                            [
                                119.39965,
                                28.774976
                            ],
                            [
                                119.404983,
                                28.767479
                            ],
                            [
                                119.408373,
                                28.764713
                            ],
                            [
                                119.411716,
                                28.763283
                            ],
                            [
                                119.412447,
                                28.761644
                            ],
                            [
                                119.412851,
                                28.754169
                            ],
                            [
                                119.413613,
                                28.751995
                            ],
                            [
                                119.416723,
                                28.750123
                            ],
                            [
                                119.421201,
                                28.749158
                            ],
                            [
                                119.426628,
                                28.75246
                            ],
                            [
                                119.430702,
                                28.755576
                            ],
                            [
                                119.434511,
                                28.756878
                            ],
                            [
                                119.440078,
                                28.756982
                            ],
                            [
                                119.446127,
                                28.758063
                            ],
                            [
                                119.449019,
                                28.760505
                            ],
                            [
                                119.455783,
                                28.761086
                            ],
                            [
                                119.463417,
                                28.766433
                            ],
                            [
                                119.465874,
                                28.766968
                            ],
                            [
                                119.47085,
                                28.765363
                            ],
                            [
                                119.472529,
                                28.762771
                            ],
                            [
                                119.472965,
                                28.75983
                            ],
                            [
                                119.471892,
                                28.755785
                            ],
                            [
                                119.473027,
                                28.749798
                            ],
                            [
                                119.474753,
                                28.746345
                            ],
                            [
                                119.479651,
                                28.73966
                            ],
                            [
                                119.482263,
                                28.737416
                            ],
                            [
                                119.487379,
                                28.730695
                            ],
                            [
                                119.489385,
                                28.72909
                            ],
                            [
                                119.491344,
                                28.729928
                            ],
                            [
                                119.494796,
                                28.735741
                            ],
                            [
                                119.499056,
                                28.737253
                            ],
                            [
                                119.499118,
                                28.740008
                            ],
                            [
                                119.496677,
                                28.741729
                            ],
                            [
                                119.495853,
                                28.747194
                            ],
                            [
                                119.501015,
                                28.752437
                            ],
                            [
                                119.506209,
                                28.763864
                            ],
                            [
                                119.513843,
                                28.771733
                            ],
                            [
                                119.521058,
                                28.77966
                            ],
                            [
                                119.522644,
                                28.783693
                            ],
                            [
                                119.52521,
                                28.786773
                            ],
                            [
                                119.529921,
                                28.79041
                            ],
                            [
                                119.54037,
                                28.787249
                            ],
                            [
                                119.544118,
                                28.789446
                            ],
                            [
                                119.553059,
                                28.79815
                            ],
                            [
                                119.557957,
                                28.804366
                            ],
                            [
                                119.562264,
                                28.809107
                            ],
                            [
                                119.564503,
                                28.814893
                            ],
                            [
                                119.564394,
                                28.819657
                            ],
                            [
                                119.561191,
                                28.823862
                            ],
                            [
                                119.557241,
                                28.826476
                            ],
                            [
                                119.556573,
                                28.831599
                            ],
                            [
                                119.561533,
                                28.837419
                            ],
                            [
                                119.567892,
                                28.843076
                            ],
                            [
                                119.576771,
                                28.847757
                            ],
                            [
                                119.58268,
                                28.8467
                            ],
                            [
                                119.586738,
                                28.843134
                            ],
                            [
                                119.590983,
                                28.840323
                            ],
                            [
                                119.593533,
                                28.840218
                            ],
                            [
                                119.596441,
                                28.843192
                            ],
                            [
                                119.600608,
                                28.849766
                            ],
                            [
                                119.600281,
                                28.855143
                            ],
                            [
                                119.601712,
                                28.85879
                            ],
                            [
                                119.607543,
                                28.864364
                            ],
                            [
                                119.608554,
                                28.866211
                            ],
                            [
                                119.609533,
                                28.871994
                            ],
                            [
                                119.611788,
                                28.873225
                            ],
                            [
                                119.614027,
                                28.872783
                            ],
                            [
                                119.623357,
                                28.868278
                            ],
                            [
                                119.626218,
                                28.863656
                            ],
                            [
                                119.629032,
                                28.862355
                            ],
                            [
                                119.632468,
                                28.863679
                            ],
                            [
                                119.634117,
                                28.865897
                            ],
                            [
                                119.636527,
                                28.876569
                            ],
                            [
                                119.639637,
                                28.878613
                            ],
                            [
                                119.646478,
                                28.885893
                            ],
                            [
                                119.649246,
                                28.889701
                            ],
                            [
                                119.65178,
                                28.895123
                            ],
                            [
                                119.651936,
                                28.899372
                            ],
                            [
                                119.650785,
                                28.904712
                            ],
                            [
                                119.650847,
                                28.909703
                            ],
                            [
                                119.651796,
                                28.916157
                            ],
                            [
                                119.654159,
                                28.91885
                            ],
                            [
                                119.656383,
                                28.919105
                            ],
                            [
                                119.667843,
                                28.918525
                            ],
                            [
                                119.672352,
                                28.916563
                            ],
                            [
                                119.676504,
                                28.91625
                            ],
                            [
                                119.681806,
                                28.918594
                            ],
                            [
                                119.684807,
                                28.922796
                            ],
                            [
                                119.692053,
                                28.929249
                            ],
                            [
                                119.695925,
                                28.931825
                            ],
                            [
                                119.699563,
                                28.932417
                            ],
                            [
                                119.703264,
                                28.931512
                            ],
                            [
                                119.708209,
                                28.934007
                            ],
                            [
                                119.714553,
                                28.933717
                            ],
                            [
                                119.719482,
                                28.935075
                            ],
                            [
                                119.721938,
                                28.937674
                            ],
                            [
                                119.721954,
                                28.940552
                            ],
                            [
                                119.716605,
                                28.943186
                            ],
                            [
                                119.716854,
                                28.945159
                            ],
                            [
                                119.71928,
                                28.947921
                            ],
                            [
                                119.73018,
                                28.954059
                            ],
                            [
                                119.732512,
                                28.957899
                            ],
                            [
                                119.733056,
                                28.960243
                            ],
                            [
                                119.730708,
                                28.965081
                            ],
                            [
                                119.732605,
                                28.971439
                            ],
                            [
                                119.734767,
                                28.975545
                            ],
                            [
                                119.737643,
                                28.9771
                            ],
                            [
                                119.744112,
                                28.97797
                            ],
                            [
                                119.746817,
                                28.979153
                            ],
                            [
                                119.74803,
                                28.980939
                            ],
                            [
                                119.747004,
                                28.985162
                            ],
                            [
                                119.747906,
                                28.987516
                            ],
                            [
                                119.75271,
                                28.98943
                            ],
                            [
                                119.755478,
                                28.98914
                            ],
                            [
                                119.75722,
                                28.987528
                            ],
                            [
                                119.760998,
                                28.988166
                            ],
                            [
                                119.764605,
                                28.991077
                            ],
                            [
                                119.769535,
                                28.993026
                            ],
                            [
                                119.769939,
                                28.995508
                            ],
                            [
                                119.767544,
                                28.997236
                            ],
                            [
                                119.765461,
                                28.996459
                            ],
                            [
                                119.758697,
                                28.992272
                            ],
                            [
                                119.757282,
                                28.992829
                            ],
                            [
                                119.754561,
                                28.996366
                            ],
                            [
                                119.750984,
                                28.998547
                            ],
                            [
                                119.74705,
                                28.998906
                            ],
                            [
                                119.74052,
                                28.995659
                            ],
                            [
                                119.736975,
                                28.994719
                            ],
                            [
                                119.731641,
                                28.995229
                            ],
                            [
                                119.72976,
                                28.996958
                            ],
                            [
                                119.731874,
                                28.998744
                            ],
                            [
                                119.738529,
                                29.001794
                            ],
                            [
                                119.738965,
                                29.002919
                            ],
                            [
                                119.737146,
                                29.009065
                            ],
                            [
                                119.734813,
                                29.01462
                            ],
                            [
                                119.733352,
                                29.021473
                            ],
                            [
                                119.735311,
                                29.029195
                            ],
                            [
                                119.741484,
                                29.036117
                            ],
                            [
                                119.743023,
                                29.041404
                            ],
                            [
                                119.74195,
                                29.044209
                            ],
                            [
                                119.736803,
                                29.046539
                            ],
                            [
                                119.729589,
                                29.048371
                            ],
                            [
                                119.719264,
                                29.051814
                            ],
                            [
                                119.714117,
                                29.050689
                            ],
                            [
                                119.712438,
                                29.048243
                            ],
                            [
                                119.709157,
                                29.045507
                            ],
                            [
                                119.709064,
                                29.042447
                            ],
                            [
                                119.70768,
                                29.04145
                            ],
                            [
                                119.7023,
                                29.040302
                            ],
                            [
                                119.694587,
                                29.037357
                            ],
                            [
                                119.691322,
                                29.036871
                            ],
                            [
                                119.685584,
                                29.038528
                            ],
                            [
                                119.67896,
                                29.043142
                            ],
                            [
                                119.676581,
                                29.046516
                            ],
                            [
                                119.675369,
                                29.056926
                            ],
                            [
                                119.671948,
                                29.062512
                            ],
                            [
                                119.671917,
                                29.067821
                            ],
                            [
                                119.676333,
                                29.0762
                            ],
                            [
                                119.673907,
                                29.082481
                            ],
                            [
                                119.670642,
                                29.085842
                            ],
                            [
                                119.663069,
                                29.090767
                            ],
                            [
                                119.665075,
                                29.091277
                            ],
                            [
                                119.669149,
                                29.095738
                            ],
                            [
                                119.673891,
                                29.099283
                            ],
                            [
                                119.674716,
                                29.102041
                            ],
                            [
                                119.673301,
                                29.107695
                            ],
                            [
                                119.668807,
                                29.113673
                            ],
                            [
                                119.667267,
                                29.114739
                            ],
                            [
                                119.667407,
                                29.118226
                            ],
                            [
                                119.675788,
                                29.137385
                            ],
                            [
                                119.675742,
                                29.139944
                            ],
                            [
                                119.673969,
                                29.141021
                            ],
                            [
                                119.674327,
                                29.145781
                            ],
                            [
                                119.671388,
                                29.15068
                            ],
                            [
                                119.669911,
                                29.159632
                            ],
                            [
                                119.66422,
                                29.171269
                            ],
                            [
                                119.660099,
                                29.180902
                            ],
                            [
                                119.660239,
                                29.184572
                            ],
                            [
                                119.661499,
                                29.187153
                            ],
                            [
                                119.657052,
                                29.191668
                            ],
                            [
                                119.658264,
                                29.196252
                            ],
                            [
                                119.656912,
                                29.19844
                            ],
                            [
                                119.652558,
                                29.197456
                            ],
                            [
                                119.65035,
                                29.198706
                            ],
                            [
                                119.651174,
                                29.201461
                            ],
                            [
                                119.657814,
                                29.208151
                            ],
                            [
                                119.661716,
                                29.210582
                            ],
                            [
                                119.66296,
                                29.213904
                            ],
                            [
                                119.665308,
                                29.21741
                            ],
                            [
                                119.674405,
                                29.222306
                            ],
                            [
                                119.680531,
                                29.222583
                            ],
                            [
                                119.690342,
                                29.224007
                            ],
                            [
                                119.696935,
                                29.222456
                            ],
                            [
                                119.69821,
                                29.224852
                            ],
                            [
                                119.698133,
                                29.228508
                            ],
                            [
                                119.699641,
                                29.23036
                            ],
                            [
                                119.70076,
                                29.228173
                            ],
                            [
                                119.703855,
                                29.226935
                            ],
                            [
                                119.709048,
                                29.229573
                            ],
                            [
                                119.710012,
                                29.236366
                            ],
                            [
                                119.710059,
                                29.240739
                            ],
                            [
                                119.708069,
                                29.239374
                            ],
                            [
                                119.701071,
                                29.237638
                            ],
                            [
                                119.681479,
                                29.233797
                            ],
                            [
                                119.676628,
                                29.230765
                            ],
                            [
                                119.667796,
                                29.230742
                            ],
                            [
                                119.661623,
                                29.226634
                            ],
                            [
                                119.655932,
                                29.22727
                            ],
                            [
                                119.645763,
                                29.223
                            ],
                            [
                                119.642684,
                                29.222317
                            ],
                            [
                                119.635376,
                                29.223428
                            ],
                            [
                                119.631069,
                                29.223104
                            ],
                            [
                                119.623745,
                                29.225303
                            ],
                            [
                                119.607792,
                                29.223474
                            ],
                            [
                                119.601074,
                                29.22602
                            ],
                            [
                                119.599317,
                                29.225453
                            ],
                            [
                                119.598711,
                                29.221901
                            ],
                            [
                                119.594933,
                                29.211774
                            ],
                            [
                                119.589366,
                                29.206299
                            ],
                            [
                                119.58254,
                                29.197271
                            ],
                            [
                                119.578217,
                                29.192305
                            ],
                            [
                                119.573257,
                                29.189689
                            ],
                            [
                                119.567628,
                                29.185648
                            ],
                            [
                                119.566446,
                                29.183981
                            ],
                            [
                                119.565249,
                                29.177394
                            ],
                            [
                                119.562201,
                                29.167946
                            ],
                            [
                                119.561937,
                                29.165259
                            ],
                            [
                                119.564581,
                                29.160547
                            ],
                            [
                                119.563445,
                                29.15544
                            ],
                            [
                                119.560693,
                                29.15185
                            ],
                            [
                                119.555733,
                                29.148387
                            ],
                            [
                                119.557024,
                                29.143442
                            ],
                            [
                                119.556433,
                                29.141786
                            ],
                            [
                                119.551379,
                                29.133493
                            ],
                            [
                                119.547912,
                                29.129856
                            ],
                            [
                                119.545268,
                                29.12996
                            ],
                            [
                                119.546497,
                                29.135647
                            ],
                            [
                                119.54617,
                                29.138948
                            ],
                            [
                                119.54502,
                                29.138624
                            ],
                            [
                                119.541988,
                                29.133365
                            ],
                            [
                                119.539733,
                                29.131674
                            ],
                            [
                                119.520219,
                                29.132369
                            ],
                            [
                                119.504545,
                                29.133551
                            ],
                            [
                                119.499974,
                                29.13003
                            ],
                            [
                                119.501715,
                                29.124168
                            ],
                            [
                                119.500393,
                                29.121261
                            ],
                            [
                                119.501155,
                                29.115978
                            ],
                            [
                                119.502446,
                                29.111669
                            ],
                            [
                                119.500611,
                                29.109502
                            ],
                            [
                                119.498605,
                                29.109224
                            ],
                            [
                                119.496195,
                                29.111078
                            ],
                            [
                                119.490349,
                                29.110707
                            ],
                            [
                                119.479278,
                                29.096305
                            ],
                            [
                                119.477521,
                                29.095819
                            ],
                            [
                                119.473167,
                                29.096572
                            ],
                            [
                                119.467958,
                                29.099863
                            ],
                            [
                                119.464863,
                                29.105297
                            ],
                            [
                                119.460945,
                                29.109201
                            ],
                            [
                                119.458022,
                                29.109525
                            ],
                            [
                                119.456171,
                                29.111842
                            ],
                            [
                                119.456047,
                                29.11592
                            ],
                            [
                                119.454928,
                                29.11943
                            ],
                            [
                                119.452129,
                                29.119581
                            ],
                            [
                                119.451647,
                                29.117635
                            ],
                            [
                                119.453995,
                                29.113545
                            ],
                            [
                                119.452922,
                                29.11212
                            ],
                            [
                                119.449967,
                                29.114507
                            ],
                            [
                                119.447371,
                                29.114785
                            ],
                            [
                                119.445925,
                                29.121909
                            ],
                            [
                                119.448879,
                                29.123844
                            ],
                            [
                                119.450652,
                                29.12791
                            ],
                            [
                                119.450076,
                                29.130203
                            ],
                            [
                                119.446562,
                                29.131246
                            ],
                            [
                                119.444914,
                                29.129763
                            ],
                            [
                                119.441353,
                                29.132531
                            ],
                            [
                                119.439021,
                                29.138392
                            ],
                            [
                                119.431277,
                                29.142388
                            ],
                            [
                                119.428805,
                                29.142793
                            ],
                            [
                                119.424886,
                                29.141149
                            ],
                            [
                                119.419988,
                                29.140361
                            ],
                            [
                                119.413753,
                                29.136203
                            ],
                            [
                                119.412385,
                                29.136168
                            ],
                            [
                                119.412245,
                                29.140697
                            ],
                            [
                                119.409773,
                                29.140778
                            ],
                            [
                                119.406787,
                                29.137153
                            ],
                            [
                                119.404299,
                                29.137176
                            ],
                            [
                                119.404408,
                                29.144762
                            ],
                            [
                                119.4029,
                                29.14621
                            ],
                            [
                                119.40049,
                                29.146337
                            ],
                            [
                                119.394643,
                                29.138288
                            ],
                            [
                                119.391238,
                                29.132983
                            ],
                            [
                                119.389248,
                                29.128906
                            ],
                            [
                                119.385671,
                                29.125014
                            ],
                            [
                                119.381318,
                                29.124968
                            ],
                            [
                                119.375891,
                                29.127551
                            ],
                            [
                                119.368458,
                                29.127991
                            ],
                            [
                                119.360808,
                                29.1263
                            ],
                            [
                                119.35731,
                                29.12294
                            ],
                            [
                                119.354915,
                                29.113754
                            ],
                            [
                                119.348866,
                                29.108958
                            ],
                            [
                                119.343486,
                                29.106837
                            ],
                            [
                                119.33027,
                                29.095993
                            ],
                            [
                                119.32562,
                                29.091775
                            ],
                            [
                                119.322977,
                                29.088403
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 330703,
                "name": "金东区",
                "center": [
                    119.681264,
                    29.095835
                ],
                "centroid": [
                    119.799596,
                    29.149391
                ],
                "childrenNum": 0,
                "level": "district",
                "parent": {
                    "adcode": 330700
                },
                "subFeatureIndex": 1,
                "acroutes": [
                    100000,
                    330000,
                    330700
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                119.819712,
                                29.306752
                            ],
                            [
                                119.813041,
                                29.304462
                            ],
                            [
                                119.807754,
                                29.302149
                            ],
                            [
                                119.80253,
                                29.301155
                            ],
                            [
                                119.799296,
                                29.297512
                            ],
                            [
                                119.7895,
                                29.294251
                            ],
                            [
                                119.785706,
                                29.291233
                            ],
                            [
                                119.780792,
                                29.288804
                            ],
                            [
                                119.776127,
                                29.28471
                            ],
                            [
                                119.771167,
                                29.28456
                            ],
                            [
                                119.768602,
                                29.28235
                            ],
                            [
                                119.759723,
                                29.272762
                            ],
                            [
                                119.755012,
                                29.270495
                            ],
                            [
                                119.748061,
                                29.26537
                            ],
                            [
                                119.747564,
                                29.261588
                            ],
                            [
                                119.744734,
                                29.256451
                            ],
                            [
                                119.742572,
                                29.255364
                            ],
                            [
                                119.733274,
                                29.253003
                            ],
                            [
                                119.724115,
                                29.25224
                            ],
                            [
                                119.719591,
                                29.249047
                            ],
                            [
                                119.714024,
                                29.246883
                            ],
                            [
                                119.710059,
                                29.240739
                            ],
                            [
                                119.710012,
                                29.236366
                            ],
                            [
                                119.709048,
                                29.229573
                            ],
                            [
                                119.703855,
                                29.226935
                            ],
                            [
                                119.70076,
                                29.228173
                            ],
                            [
                                119.699641,
                                29.23036
                            ],
                            [
                                119.698133,
                                29.228508
                            ],
                            [
                                119.69821,
                                29.224852
                            ],
                            [
                                119.696935,
                                29.222456
                            ],
                            [
                                119.690342,
                                29.224007
                            ],
                            [
                                119.680531,
                                29.222583
                            ],
                            [
                                119.674405,
                                29.222306
                            ],
                            [
                                119.665308,
                                29.21741
                            ],
                            [
                                119.66296,
                                29.213904
                            ],
                            [
                                119.661716,
                                29.210582
                            ],
                            [
                                119.657814,
                                29.208151
                            ],
                            [
                                119.651174,
                                29.201461
                            ],
                            [
                                119.65035,
                                29.198706
                            ],
                            [
                                119.652558,
                                29.197456
                            ],
                            [
                                119.656912,
                                29.19844
                            ],
                            [
                                119.658264,
                                29.196252
                            ],
                            [
                                119.657052,
                                29.191668
                            ],
                            [
                                119.661499,
                                29.187153
                            ],
                            [
                                119.660239,
                                29.184572
                            ],
                            [
                                119.660099,
                                29.180902
                            ],
                            [
                                119.66422,
                                29.171269
                            ],
                            [
                                119.669911,
                                29.159632
                            ],
                            [
                                119.671388,
                                29.15068
                            ],
                            [
                                119.674327,
                                29.145781
                            ],
                            [
                                119.673969,
                                29.141021
                            ],
                            [
                                119.675742,
                                29.139944
                            ],
                            [
                                119.675788,
                                29.137385
                            ],
                            [
                                119.667407,
                                29.118226
                            ],
                            [
                                119.667267,
                                29.114739
                            ],
                            [
                                119.668807,
                                29.113673
                            ],
                            [
                                119.673301,
                                29.107695
                            ],
                            [
                                119.674716,
                                29.102041
                            ],
                            [
                                119.673891,
                                29.099283
                            ],
                            [
                                119.669149,
                                29.095738
                            ],
                            [
                                119.665075,
                                29.091277
                            ],
                            [
                                119.663069,
                                29.090767
                            ],
                            [
                                119.670642,
                                29.085842
                            ],
                            [
                                119.673907,
                                29.082481
                            ],
                            [
                                119.676333,
                                29.0762
                            ],
                            [
                                119.671917,
                                29.067821
                            ],
                            [
                                119.671948,
                                29.062512
                            ],
                            [
                                119.675369,
                                29.056926
                            ],
                            [
                                119.676581,
                                29.046516
                            ],
                            [
                                119.67896,
                                29.043142
                            ],
                            [
                                119.685584,
                                29.038528
                            ],
                            [
                                119.691322,
                                29.036871
                            ],
                            [
                                119.694587,
                                29.037357
                            ],
                            [
                                119.7023,
                                29.040302
                            ],
                            [
                                119.70768,
                                29.04145
                            ],
                            [
                                119.709064,
                                29.042447
                            ],
                            [
                                119.709157,
                                29.045507
                            ],
                            [
                                119.712438,
                                29.048243
                            ],
                            [
                                119.714117,
                                29.050689
                            ],
                            [
                                119.719264,
                                29.051814
                            ],
                            [
                                119.729589,
                                29.048371
                            ],
                            [
                                119.736803,
                                29.046539
                            ],
                            [
                                119.74195,
                                29.044209
                            ],
                            [
                                119.743023,
                                29.041404
                            ],
                            [
                                119.741484,
                                29.036117
                            ],
                            [
                                119.735311,
                                29.029195
                            ],
                            [
                                119.733352,
                                29.021473
                            ],
                            [
                                119.734813,
                                29.01462
                            ],
                            [
                                119.737146,
                                29.009065
                            ],
                            [
                                119.738965,
                                29.002919
                            ],
                            [
                                119.738529,
                                29.001794
                            ],
                            [
                                119.731874,
                                28.998744
                            ],
                            [
                                119.72976,
                                28.996958
                            ],
                            [
                                119.731641,
                                28.995229
                            ],
                            [
                                119.736975,
                                28.994719
                            ],
                            [
                                119.74052,
                                28.995659
                            ],
                            [
                                119.74705,
                                28.998906
                            ],
                            [
                                119.750984,
                                28.998547
                            ],
                            [
                                119.754561,
                                28.996366
                            ],
                            [
                                119.757282,
                                28.992829
                            ],
                            [
                                119.758697,
                                28.992272
                            ],
                            [
                                119.765461,
                                28.996459
                            ],
                            [
                                119.767544,
                                28.997236
                            ],
                            [
                                119.769939,
                                28.995508
                            ],
                            [
                                119.769535,
                                28.993026
                            ],
                            [
                                119.773904,
                                28.997016
                            ],
                            [
                                119.774961,
                                29.000854
                            ],
                            [
                                119.777325,
                                29.002385
                            ],
                            [
                                119.782067,
                                29.003905
                            ],
                            [
                                119.788987,
                                29.004948
                            ],
                            [
                                119.792578,
                                29.007558
                            ],
                            [
                                119.798036,
                                29.007917
                            ],
                            [
                                119.811253,
                                29.0107
                            ],
                            [
                                119.814114,
                                29.009065
                            ],
                            [
                                119.823848,
                                29.006131
                            ],
                            [
                                119.833084,
                                29.007894
                            ],
                            [
                                119.834717,
                                29.009483
                            ],
                            [
                                119.834484,
                                29.014829
                            ],
                            [
                                119.842631,
                                29.027375
                            ],
                            [
                                119.849877,
                                29.029891
                            ],
                            [
                                119.853671,
                                29.032163
                            ],
                            [
                                119.859051,
                                29.030343
                            ],
                            [
                                119.862643,
                                29.032836
                            ],
                            [
                                119.868505,
                                29.034575
                            ],
                            [
                                119.870946,
                                29.038679
                            ],
                            [
                                119.87488,
                                29.043815
                            ],
                            [
                                119.880338,
                                29.049681
                            ],
                            [
                                119.884972,
                                29.052173
                            ],
                            [
                                119.895654,
                                29.052208
                            ],
                            [
                                119.897147,
                                29.050133
                            ],
                            [
                                119.901065,
                                29.052637
                            ],
                            [
                                119.901532,
                                29.054468
                            ],
                            [
                                119.900505,
                                29.057563
                            ],
                            [
                                119.902356,
                                29.059452
                            ],
                            [
                                119.911841,
                                29.065468
                            ],
                            [
                                119.916055,
                                29.070139
                            ],
                            [
                                119.914173,
                                29.071993
                            ],
                            [
                                119.909617,
                                29.072295
                            ],
                            [
                                119.906507,
                                29.075702
                            ],
                            [
                                119.906414,
                                29.080233
                            ],
                            [
                                119.90814,
                                29.08298
                            ],
                            [
                                119.912432,
                                29.08393
                            ],
                            [
                                119.916614,
                                29.083895
                            ],
                            [
                                119.918294,
                                29.089226
                            ],
                            [
                                119.921108,
                                29.091497
                            ],
                            [
                                119.92243,
                                29.094417
                            ],
                            [
                                119.916521,
                                29.096514
                            ],
                            [
                                119.915417,
                                29.097951
                            ],
                            [
                                119.918185,
                                29.101543
                            ],
                            [
                                119.917718,
                                29.108251
                            ],
                            [
                                119.918978,
                                29.110707
                            ],
                            [
                                119.921792,
                                29.1119
                            ],
                            [
                                119.933299,
                                29.113789
                            ],
                            [
                                119.940032,
                                29.11577
                            ],
                            [
                                119.943141,
                                29.118249
                            ],
                            [
                                119.943732,
                                29.121342
                            ],
                            [
                                119.943561,
                                29.128906
                            ],
                            [
                                119.944261,
                                29.13113
                            ],
                            [
                                119.94706,
                                29.134118
                            ],
                            [
                                119.948428,
                                29.137257
                            ],
                            [
                                119.949003,
                                29.142122
                            ],
                            [
                                119.948615,
                                29.145446
                            ],
                            [
                                119.946795,
                                29.147078
                            ],
                            [
                                119.941866,
                                29.148642
                            ],
                            [
                                119.939705,
                                29.15119
                            ],
                            [
                                119.938757,
                                29.160257
                            ],
                            [
                                119.939239,
                                29.163233
                            ],
                            [
                                119.93871,
                                29.172079
                            ],
                            [
                                119.932957,
                                29.176085
                            ],
                            [
                                119.931091,
                                29.180543
                            ],
                            [
                                119.926986,
                                29.183993
                            ],
                            [
                                119.926861,
                                29.187883
                            ],
                            [
                                119.929629,
                                29.192143
                            ],
                            [
                                119.926146,
                                29.199551
                            ],
                            [
                                119.923674,
                                29.198417
                            ],
                            [
                                119.923487,
                                29.196993
                            ],
                            [
                                119.920517,
                                29.195106
                            ],
                            [
                                119.918869,
                                29.195465
                            ],
                            [
                                119.917765,
                                29.197745
                            ],
                            [
                                119.91506,
                                29.197224
                            ],
                            [
                                119.915044,
                                29.199077
                            ],
                            [
                                119.911934,
                                29.199979
                            ],
                            [
                                119.911794,
                                29.203417
                            ],
                            [
                                119.91366,
                                29.208024
                            ],
                            [
                                119.91565,
                                29.210512
                            ],
                            [
                                119.914173,
                                29.212816
                            ],
                            [
                                119.913582,
                                29.216114
                            ],
                            [
                                119.910037,
                                29.219135
                            ],
                            [
                                119.911763,
                                29.219655
                            ],
                            [
                                119.910146,
                                29.223775
                            ],
                            [
                                119.911266,
                                29.22521
                            ],
                            [
                                119.912447,
                                29.223486
                            ],
                            [
                                119.913707,
                                29.227259
                            ],
                            [
                                119.912338,
                                29.233218
                            ],
                            [
                                119.915635,
                                29.235
                            ],
                            [
                                119.916164,
                                29.236828
                            ],
                            [
                                119.913971,
                                29.239258
                            ],
                            [
                                119.912929,
                                29.244025
                            ],
                            [
                                119.915635,
                                29.248167
                            ],
                            [
                                119.913209,
                                29.248191
                            ],
                            [
                                119.912541,
                                29.250875
                            ],
                            [
                                119.909835,
                                29.250019
                            ],
                            [
                                119.908576,
                                29.252032
                            ],
                            [
                                119.905217,
                                29.251962
                            ],
                            [
                                119.904844,
                                29.257712
                            ],
                            [
                                119.901781,
                                29.259424
                            ],
                            [
                                119.898204,
                                29.263901
                            ],
                            [
                                119.895732,
                                29.265104
                            ],
                            [
                                119.895079,
                                29.263311
                            ],
                            [
                                119.892078,
                                29.263068
                            ],
                            [
                                119.891378,
                                29.267996
                            ],
                            [
                                119.889637,
                                29.26935
                            ],
                            [
                                119.888937,
                                29.272045
                            ],
                            [
                                119.890227,
                                29.273178
                            ],
                            [
                                119.884739,
                                29.273595
                            ],
                            [
                                119.881598,
                                29.272288
                            ],
                            [
                                119.876902,
                                29.272438
                            ],
                            [
                                119.87359,
                                29.274809
                            ],
                            [
                                119.870698,
                                29.280165
                            ],
                            [
                                119.870122,
                                29.282975
                            ],
                            [
                                119.866375,
                                29.285936
                            ],
                            [
                                119.859114,
                                29.284849
                            ],
                            [
                                119.854387,
                                29.286884
                            ],
                            [
                                119.845446,
                                29.295327
                            ],
                            [
                                119.841605,
                                29.295928
                            ],
                            [
                                119.840252,
                                29.298576
                            ],
                            [
                                119.819712,
                                29.306752
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 330723,
                "name": "武义县",
                "center": [
                    119.819159,
                    28.896563
                ],
                "centroid": [
                    119.714529,
                    28.768287
                ],
                "childrenNum": 0,
                "level": "district",
                "parent": {
                    "adcode": 330700
                },
                "subFeatureIndex": 2,
                "acroutes": [
                    100000,
                    330000,
                    330700
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                119.479651,
                                28.73966
                            ],
                            [
                                119.471223,
                                28.740136
                            ],
                            [
                                119.463744,
                                28.742311
                            ],
                            [
                                119.461691,
                                28.741625
                            ],
                            [
                                119.460821,
                                28.73945
                            ],
                            [
                                119.461303,
                                28.733474
                            ],
                            [
                                119.463464,
                                28.719311
                            ],
                            [
                                119.463106,
                                28.714671
                            ],
                            [
                                119.464226,
                                28.708251
                            ],
                            [
                                119.46306,
                                28.700842
                            ],
                            [
                                119.462142,
                                28.690909
                            ],
                            [
                                119.459577,
                                28.686116
                            ],
                            [
                                119.458924,
                                28.679473
                            ],
                            [
                                119.461878,
                                28.671213
                            ],
                            [
                                119.462251,
                                28.66123
                            ],
                            [
                                119.458348,
                                28.65241
                            ],
                            [
                                119.455689,
                                28.650874
                            ],
                            [
                                119.456234,
                                28.646685
                            ],
                            [
                                119.457524,
                                28.64537
                            ],
                            [
                                119.459064,
                                28.639272
                            ],
                            [
                                119.461209,
                                28.634884
                            ],
                            [
                                119.464568,
                                28.633488
                            ],
                            [
                                119.468455,
                                28.633639
                            ],
                            [
                                119.475655,
                                28.637794
                            ],
                            [
                                119.482045,
                                28.639458
                            ],
                            [
                                119.486492,
                                28.637212
                            ],
                            [
                                119.485357,
                                28.632079
                            ],
                            [
                                119.485839,
                                28.629577
                            ],
                            [
                                119.488421,
                                28.626458
                            ],
                            [
                                119.495293,
                                28.622209
                            ],
                            [
                                119.507935,
                                28.615318
                            ],
                            [
                                119.509723,
                                28.611768
                            ],
                            [
                                119.509894,
                                28.603362
                            ],
                            [
                                119.508463,
                                28.598461
                            ],
                            [
                                119.506193,
                                28.5942
                            ],
                            [
                                119.503643,
                                28.5925
                            ],
                            [
                                119.500907,
                                28.588122
                            ],
                            [
                                119.498077,
                                28.58485
                            ],
                            [
                                119.495915,
                                28.578865
                            ],
                            [
                                119.497626,
                                28.574032
                            ],
                            [
                                119.495962,
                                28.566975
                            ],
                            [
                                119.495122,
                                28.557238
                            ],
                            [
                                119.493847,
                                28.555806
                            ],
                            [
                                119.495355,
                                28.551566
                            ],
                            [
                                119.498403,
                                28.548654
                            ],
                            [
                                119.500875,
                                28.549027
                            ],
                            [
                                119.504887,
                                28.552568
                            ],
                            [
                                119.508759,
                                28.559766
                            ],
                            [
                                119.511573,
                                28.561559
                            ],
                            [
                                119.514636,
                                28.561653
                            ],
                            [
                                119.522162,
                                28.558729
                            ],
                            [
                                119.530139,
                                28.557588
                            ],
                            [
                                119.534866,
                                28.555736
                            ],
                            [
                                119.53709,
                                28.549819
                            ],
                            [
                                119.535161,
                                28.543797
                            ],
                            [
                                119.536887,
                                28.539883
                            ],
                            [
                                119.540712,
                                28.533557
                            ],
                            [
                                119.543092,
                                28.532567
                            ],
                            [
                                119.559574,
                                28.532917
                            ],
                            [
                                119.568514,
                                28.532287
                            ],
                            [
                                119.57279,
                                28.52913
                            ],
                            [
                                119.574205,
                                28.523876
                            ],
                            [
                                119.58128,
                                28.523678
                            ],
                            [
                                119.584748,
                                28.524051
                            ],
                            [
                                119.58949,
                                28.527464
                            ],
                            [
                                119.592196,
                                28.527534
                            ],
                            [
                                119.59641,
                                28.525787
                            ],
                            [
                                119.608274,
                                28.526532
                            ],
                            [
                                119.613389,
                                28.527802
                            ],
                            [
                                119.621195,
                                28.526113
                            ],
                            [
                                119.629141,
                                28.525402
                            ],
                            [
                                119.634816,
                                28.526288
                            ],
                            [
                                119.638268,
                                28.528513
                            ],
                            [
                                119.644737,
                                28.541863
                            ],
                            [
                                119.649355,
                                28.542515
                            ],
                            [
                                119.660239,
                                28.539964
                            ],
                            [
                                119.664748,
                                28.537332
                            ],
                            [
                                119.671357,
                                28.531821
                            ],
                            [
                                119.674747,
                                28.530027
                            ],
                            [
                                119.682397,
                                28.529585
                            ],
                            [
                                119.695505,
                                28.531111
                            ],
                            [
                                119.70359,
                                28.533219
                            ],
                            [
                                119.705705,
                                28.535468
                            ],
                            [
                                119.707369,
                                28.539871
                            ],
                            [
                                119.707789,
                                28.545742
                            ],
                            [
                                119.717709,
                                28.553779
                            ],
                            [
                                119.718564,
                                28.557273
                            ],
                            [
                                119.718331,
                                28.561886
                            ],
                            [
                                119.720446,
                                28.565938
                            ],
                            [
                                119.726992,
                                28.571901
                            ],
                            [
                                119.73273,
                                28.578923
                            ],
                            [
                                119.737099,
                                28.581427
                            ],
                            [
                                119.739307,
                                28.58485
                            ],
                            [
                                119.738545,
                                28.589182
                            ],
                            [
                                119.739882,
                                28.591464
                            ],
                            [
                                119.743987,
                                28.59243
                            ],
                            [
                                119.75411,
                                28.592651
                            ],
                            [
                                119.758308,
                                28.591347
                            ],
                            [
                                119.763781,
                                28.588204
                            ],
                            [
                                119.767062,
                                28.588006
                            ],
                            [
                                119.767638,
                                28.591534
                            ],
                            [
                                119.769286,
                                28.595457
                            ],
                            [
                                119.772986,
                                28.599975
                            ],
                            [
                                119.773966,
                                28.603246
                            ],
                            [
                                119.772738,
                                28.608566
                            ],
                            [
                                119.767933,
                                28.611011
                            ],
                            [
                                119.762071,
                                28.615469
                            ],
                            [
                                119.749398,
                                28.622721
                            ],
                            [
                                119.75044,
                                28.629018
                            ],
                            [
                                119.75243,
                                28.635233
                            ],
                            [
                                119.757733,
                                28.63784
                            ],
                            [
                                119.764948,
                                28.638702
                            ],
                            [
                                119.769628,
                                28.636711
                            ],
                            [
                                119.777247,
                                28.630892
                            ],
                            [
                                119.783482,
                                28.629216
                            ],
                            [
                                119.78681,
                                28.629135
                            ],
                            [
                                119.790386,
                                28.630322
                            ],
                            [
                                119.794973,
                                28.632882
                            ],
                            [
                                119.802903,
                                28.643077
                            ],
                            [
                                119.807739,
                                28.647744
                            ],
                            [
                                119.811735,
                                28.653935
                            ],
                            [
                                119.812202,
                                28.658054
                            ],
                            [
                                119.81018,
                                28.661044
                            ],
                            [
                                119.810165,
                                28.663674
                            ],
                            [
                                119.812217,
                                28.66756
                            ],
                            [
                                119.813865,
                                28.678787
                            ],
                            [
                                119.813881,
                                28.686849
                            ],
                            [
                                119.815887,
                                28.689897
                            ],
                            [
                                119.826382,
                                28.695329
                            ],
                            [
                                119.832136,
                                28.70104
                            ],
                            [
                                119.835028,
                                28.704878
                            ],
                            [
                                119.842103,
                                28.708332
                            ],
                            [
                                119.844715,
                                28.714368
                            ],
                            [
                                119.84966,
                                28.716589
                            ],
                            [
                                119.861259,
                                28.717718
                            ],
                            [
                                119.866188,
                                28.718508
                            ],
                            [
                                119.868536,
                                28.722474
                            ],
                            [
                                119.86992,
                                28.726544
                            ],
                            [
                                119.873668,
                                28.732288
                            ],
                            [
                                119.874445,
                                28.735393
                            ],
                            [
                                119.871786,
                                28.742299
                            ],
                            [
                                119.880012,
                                28.748717
                            ],
                            [
                                119.882375,
                                28.749205
                            ],
                            [
                                119.88676,
                                28.744636
                            ],
                            [
                                119.890181,
                                28.744903
                            ],
                            [
                                119.89808,
                                28.750379
                            ],
                            [
                                119.901656,
                                28.755611
                            ],
                            [
                                119.900677,
                                28.758482
                            ],
                            [
                                119.903133,
                                28.763655
                            ],
                            [
                                119.906756,
                                28.768537
                            ],
                            [
                                119.914422,
                                28.773395
                            ],
                            [
                                119.915308,
                                28.77472
                            ],
                            [
                                119.915199,
                                28.778835
                            ],
                            [
                                119.919398,
                                28.780811
                            ],
                            [
                                119.921015,
                                28.784007
                            ],
                            [
                                119.92131,
                                28.796151
                            ],
                            [
                                119.928199,
                                28.79751
                            ],
                            [
                                119.932319,
                                28.795837
                            ],
                            [
                                119.929163,
                                28.80188
                            ],
                            [
                                119.931153,
                                28.804064
                            ],
                            [
                                119.940187,
                                28.806458
                            ],
                            [
                                119.94608,
                                28.808619
                            ],
                            [
                                119.957213,
                                28.807515
                            ],
                            [
                                119.959966,
                                28.807887
                            ],
                            [
                                119.969373,
                                28.811152
                            ],
                            [
                                119.971892,
                                28.815881
                            ],
                            [
                                119.974566,
                                28.818832
                            ],
                            [
                                119.974908,
                                28.823351
                            ],
                            [
                                119.968129,
                                28.833318
                            ],
                            [
                                119.965455,
                                28.839196
                            ],
                            [
                                119.967834,
                                28.843877
                            ],
                            [
                                119.970741,
                                28.845863
                            ],
                            [
                                119.973089,
                                28.849139
                            ],
                            [
                                119.973447,
                                28.851136
                            ],
                            [
                                119.971472,
                                28.855933
                            ],
                            [
                                119.969171,
                                28.864155
                            ],
                            [
                                119.966885,
                                28.868615
                            ],
                            [
                                119.961163,
                                28.870705
                            ],
                            [
                                119.958706,
                                28.870264
                            ],
                            [
                                119.951989,
                                28.875675
                            ],
                            [
                                119.950387,
                                28.877823
                            ],
                            [
                                119.944463,
                                28.883013
                            ],
                            [
                                119.940529,
                                28.887959
                            ],
                            [
                                119.93955,
                                28.890293
                            ],
                            [
                                119.940032,
                                28.893729
                            ],
                            [
                                119.93759,
                                28.895866
                            ],
                            [
                                119.927996,
                                28.89626
                            ],
                            [
                                119.924467,
                                28.897189
                            ],
                            [
                                119.924933,
                                28.903574
                            ],
                            [
                                119.923472,
                                28.907068
                            ],
                            [
                                119.919429,
                                28.910609
                            ],
                            [
                                119.918947,
                                28.912675
                            ],
                            [
                                119.921373,
                                28.919279
                            ],
                            [
                                119.922352,
                                28.92615
                            ],
                            [
                                119.918838,
                                28.928355
                            ],
                            [
                                119.910923,
                                28.931466
                            ],
                            [
                                119.90671,
                                28.938521
                            ],
                            [
                                119.902838,
                                28.942421
                            ],
                            [
                                119.901703,
                                28.945739
                            ],
                            [
                                119.903849,
                                28.947584
                            ],
                            [
                                119.910317,
                                28.946087
                            ],
                            [
                                119.916381,
                                28.948988
                            ],
                            [
                                119.919569,
                                28.949789
                            ],
                            [
                                119.923285,
                                28.952098
                            ],
                            [
                                119.925322,
                                28.954871
                            ],
                            [
                                119.927048,
                                28.962912
                            ],
                            [
                                119.931433,
                                28.967668
                            ],
                            [
                                119.936782,
                                28.967413
                            ],
                            [
                                119.940094,
                                28.970673
                            ],
                            [
                                119.942768,
                                28.978097
                            ],
                            [
                                119.942706,
                                28.980731
                            ],
                            [
                                119.941307,
                                28.982134
                            ],
                            [
                                119.933967,
                                28.982877
                            ],
                            [
                                119.931448,
                                28.9845
                            ],
                            [
                                119.928961,
                                28.988027
                            ],
                            [
                                119.930173,
                                28.991993
                            ],
                            [
                                119.929707,
                                28.994
                            ],
                            [
                                119.926193,
                                28.999161
                            ],
                            [
                                119.922041,
                                29.000959
                            ],
                            [
                                119.916164,
                                28.999625
                            ],
                            [
                                119.909711,
                                28.998744
                            ],
                            [
                                119.906818,
                                28.996958
                            ],
                            [
                                119.910379,
                                28.995995
                            ],
                            [
                                119.909166,
                                28.993698
                            ],
                            [
                                119.907658,
                                28.994789
                            ],
                            [
                                119.901501,
                                28.99291
                            ],
                            [
                                119.899324,
                                28.990277
                            ],
                            [
                                119.895359,
                                28.992527
                            ],
                            [
                                119.898624,
                                28.996969
                            ],
                            [
                                119.897085,
                                29.008915
                            ],
                            [
                                119.895607,
                                29.011106
                            ],
                            [
                                119.897333,
                                29.014179
                            ],
                            [
                                119.895872,
                                29.021821
                            ],
                            [
                                119.896012,
                                29.023595
                            ],
                            [
                                119.900148,
                                29.026842
                            ],
                            [
                                119.904066,
                                29.027039
                            ],
                            [
                                119.908902,
                                29.029474
                            ],
                            [
                                119.911063,
                                29.031352
                            ],
                            [
                                119.918698,
                                29.041519
                            ],
                            [
                                119.914049,
                                29.046817
                            ],
                            [
                                119.909819,
                                29.047872
                            ],
                            [
                                119.905061,
                                29.04647
                            ],
                            [
                                119.898671,
                                29.046736
                            ],
                            [
                                119.896789,
                                29.047953
                            ],
                            [
                                119.897147,
                                29.050133
                            ],
                            [
                                119.895654,
                                29.052208
                            ],
                            [
                                119.884972,
                                29.052173
                            ],
                            [
                                119.880338,
                                29.049681
                            ],
                            [
                                119.87488,
                                29.043815
                            ],
                            [
                                119.870946,
                                29.038679
                            ],
                            [
                                119.868505,
                                29.034575
                            ],
                            [
                                119.862643,
                                29.032836
                            ],
                            [
                                119.859051,
                                29.030343
                            ],
                            [
                                119.853671,
                                29.032163
                            ],
                            [
                                119.849877,
                                29.029891
                            ],
                            [
                                119.842631,
                                29.027375
                            ],
                            [
                                119.834484,
                                29.014829
                            ],
                            [
                                119.834717,
                                29.009483
                            ],
                            [
                                119.833084,
                                29.007894
                            ],
                            [
                                119.823848,
                                29.006131
                            ],
                            [
                                119.814114,
                                29.009065
                            ],
                            [
                                119.811253,
                                29.0107
                            ],
                            [
                                119.798036,
                                29.007917
                            ],
                            [
                                119.792578,
                                29.007558
                            ],
                            [
                                119.788987,
                                29.004948
                            ],
                            [
                                119.782067,
                                29.003905
                            ],
                            [
                                119.777325,
                                29.002385
                            ],
                            [
                                119.774961,
                                29.000854
                            ],
                            [
                                119.773904,
                                28.997016
                            ],
                            [
                                119.769535,
                                28.993026
                            ],
                            [
                                119.764605,
                                28.991077
                            ],
                            [
                                119.760998,
                                28.988166
                            ],
                            [
                                119.75722,
                                28.987528
                            ],
                            [
                                119.755478,
                                28.98914
                            ],
                            [
                                119.75271,
                                28.98943
                            ],
                            [
                                119.747906,
                                28.987516
                            ],
                            [
                                119.747004,
                                28.985162
                            ],
                            [
                                119.74803,
                                28.980939
                            ],
                            [
                                119.746817,
                                28.979153
                            ],
                            [
                                119.744112,
                                28.97797
                            ],
                            [
                                119.737643,
                                28.9771
                            ],
                            [
                                119.734767,
                                28.975545
                            ],
                            [
                                119.732605,
                                28.971439
                            ],
                            [
                                119.730708,
                                28.965081
                            ],
                            [
                                119.733056,
                                28.960243
                            ],
                            [
                                119.732512,
                                28.957899
                            ],
                            [
                                119.73018,
                                28.954059
                            ],
                            [
                                119.71928,
                                28.947921
                            ],
                            [
                                119.716854,
                                28.945159
                            ],
                            [
                                119.716605,
                                28.943186
                            ],
                            [
                                119.721954,
                                28.940552
                            ],
                            [
                                119.721938,
                                28.937674
                            ],
                            [
                                119.719482,
                                28.935075
                            ],
                            [
                                119.714553,
                                28.933717
                            ],
                            [
                                119.708209,
                                28.934007
                            ],
                            [
                                119.703264,
                                28.931512
                            ],
                            [
                                119.699563,
                                28.932417
                            ],
                            [
                                119.695925,
                                28.931825
                            ],
                            [
                                119.692053,
                                28.929249
                            ],
                            [
                                119.684807,
                                28.922796
                            ],
                            [
                                119.681806,
                                28.918594
                            ],
                            [
                                119.676504,
                                28.91625
                            ],
                            [
                                119.672352,
                                28.916563
                            ],
                            [
                                119.667843,
                                28.918525
                            ],
                            [
                                119.656383,
                                28.919105
                            ],
                            [
                                119.654159,
                                28.91885
                            ],
                            [
                                119.651796,
                                28.916157
                            ],
                            [
                                119.650847,
                                28.909703
                            ],
                            [
                                119.650785,
                                28.904712
                            ],
                            [
                                119.651936,
                                28.899372
                            ],
                            [
                                119.65178,
                                28.895123
                            ],
                            [
                                119.649246,
                                28.889701
                            ],
                            [
                                119.646478,
                                28.885893
                            ],
                            [
                                119.639637,
                                28.878613
                            ],
                            [
                                119.636527,
                                28.876569
                            ],
                            [
                                119.634117,
                                28.865897
                            ],
                            [
                                119.632468,
                                28.863679
                            ],
                            [
                                119.629032,
                                28.862355
                            ],
                            [
                                119.626218,
                                28.863656
                            ],
                            [
                                119.623357,
                                28.868278
                            ],
                            [
                                119.614027,
                                28.872783
                            ],
                            [
                                119.611788,
                                28.873225
                            ],
                            [
                                119.609533,
                                28.871994
                            ],
                            [
                                119.608554,
                                28.866211
                            ],
                            [
                                119.607543,
                                28.864364
                            ],
                            [
                                119.601712,
                                28.85879
                            ],
                            [
                                119.600281,
                                28.855143
                            ],
                            [
                                119.600608,
                                28.849766
                            ],
                            [
                                119.596441,
                                28.843192
                            ],
                            [
                                119.593533,
                                28.840218
                            ],
                            [
                                119.590983,
                                28.840323
                            ],
                            [
                                119.586738,
                                28.843134
                            ],
                            [
                                119.58268,
                                28.8467
                            ],
                            [
                                119.576771,
                                28.847757
                            ],
                            [
                                119.567892,
                                28.843076
                            ],
                            [
                                119.561533,
                                28.837419
                            ],
                            [
                                119.556573,
                                28.831599
                            ],
                            [
                                119.557241,
                                28.826476
                            ],
                            [
                                119.561191,
                                28.823862
                            ],
                            [
                                119.564394,
                                28.819657
                            ],
                            [
                                119.564503,
                                28.814893
                            ],
                            [
                                119.562264,
                                28.809107
                            ],
                            [
                                119.557957,
                                28.804366
                            ],
                            [
                                119.553059,
                                28.79815
                            ],
                            [
                                119.544118,
                                28.789446
                            ],
                            [
                                119.54037,
                                28.787249
                            ],
                            [
                                119.529921,
                                28.79041
                            ],
                            [
                                119.52521,
                                28.786773
                            ],
                            [
                                119.522644,
                                28.783693
                            ],
                            [
                                119.521058,
                                28.77966
                            ],
                            [
                                119.513843,
                                28.771733
                            ],
                            [
                                119.506209,
                                28.763864
                            ],
                            [
                                119.501015,
                                28.752437
                            ],
                            [
                                119.495853,
                                28.747194
                            ],
                            [
                                119.496677,
                                28.741729
                            ],
                            [
                                119.499118,
                                28.740008
                            ],
                            [
                                119.499056,
                                28.737253
                            ],
                            [
                                119.494796,
                                28.735741
                            ],
                            [
                                119.491344,
                                28.729928
                            ],
                            [
                                119.489385,
                                28.72909
                            ],
                            [
                                119.487379,
                                28.730695
                            ],
                            [
                                119.482263,
                                28.737416
                            ],
                            [
                                119.479651,
                                28.73966
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 330726,
                "name": "浦江县",
                "center": [
                    119.893363,
                    29.451254
                ],
                "centroid": [
                    119.903937,
                    29.520086
                ],
                "childrenNum": 0,
                "level": "district",
                "parent": {
                    "adcode": 330700
                },
                "subFeatureIndex": 3,
                "acroutes": [
                    100000,
                    330000,
                    330700
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                119.713433,
                                29.456189
                            ],
                            [
                                119.723898,
                                29.453914
                            ],
                            [
                                119.727769,
                                29.453429
                            ],
                            [
                                119.733771,
                                29.450207
                            ],
                            [
                                119.736368,
                                29.445947
                            ],
                            [
                                119.738623,
                                29.440311
                            ],
                            [
                                119.741826,
                                29.439676
                            ],
                            [
                                119.743847,
                                29.437828
                            ],
                            [
                                119.748496,
                                29.429201
                            ],
                            [
                                119.748357,
                                29.426915
                            ],
                            [
                                119.745262,
                                29.423773
                            ],
                            [
                                119.744531,
                                29.42114
                            ],
                            [
                                119.749212,
                                29.417744
                            ],
                            [
                                119.752026,
                                29.416577
                            ],
                            [
                                119.755618,
                                29.416508
                            ],
                            [
                                119.761993,
                                29.413262
                            ],
                            [
                                119.765912,
                                29.407336
                            ],
                            [
                                119.769923,
                                29.406019
                            ],
                            [
                                119.775459,
                                29.402011
                            ],
                            [
                                119.781585,
                                29.400625
                            ],
                            [
                                119.786234,
                                29.401352
                            ],
                            [
                                119.795937,
                                29.397159
                            ],
                            [
                                119.799653,
                                29.396558
                            ],
                            [
                                119.802312,
                                29.394929
                            ],
                            [
                                119.802685,
                                29.391382
                            ],
                            [
                                119.804443,
                                29.389418
                            ],
                            [
                                119.807941,
                                29.387904
                            ],
                            [
                                119.814752,
                                29.391012
                            ],
                            [
                                119.81329,
                                29.39687
                            ],
                            [
                                119.814239,
                                29.400752
                            ],
                            [
                                119.818888,
                                29.4029
                            ],
                            [
                                119.820225,
                                29.409531
                            ],
                            [
                                119.822915,
                                29.41146
                            ],
                            [
                                119.829943,
                                29.408422
                            ],
                            [
                                119.834064,
                                29.408676
                            ],
                            [
                                119.835588,
                                29.412615
                            ],
                            [
                                119.839133,
                                29.415688
                            ],
                            [
                                119.840968,
                                29.416242
                            ],
                            [
                                119.844342,
                                29.413932
                            ],
                            [
                                119.849893,
                                29.413597
                            ],
                            [
                                119.856657,
                                29.410109
                            ],
                            [
                                119.865069,
                                29.409751
                            ],
                            [
                                119.868427,
                                29.405373
                            ],
                            [
                                119.871615,
                                29.404599
                            ],
                            [
                                119.874849,
                                29.407671
                            ],
                            [
                                119.878985,
                                29.410167
                            ],
                            [
                                119.882049,
                                29.409624
                            ],
                            [
                                119.885345,
                                29.405014
                            ],
                            [
                                119.890865,
                                29.401433
                            ],
                            [
                                119.890305,
                                29.394213
                            ],
                            [
                                119.892529,
                                29.38824
                            ],
                            [
                                119.890103,
                                29.385501
                            ],
                            [
                                119.889683,
                                29.382925
                            ],
                            [
                                119.894084,
                                29.378522
                            ],
                            [
                                119.894566,
                                29.372282
                            ],
                            [
                                119.89553,
                                29.370618
                            ],
                            [
                                119.899106,
                                29.369208
                            ],
                            [
                                119.902418,
                                29.371161
                            ],
                            [
                                119.904579,
                                29.374513
                            ],
                            [
                                119.904735,
                                29.37858
                            ],
                            [
                                119.906694,
                                29.385767
                            ],
                            [
                                119.908109,
                                29.387627
                            ],
                            [
                                119.911452,
                                29.388043
                            ],
                            [
                                119.913645,
                                29.386807
                            ],
                            [
                                119.915542,
                                29.383964
                            ],
                            [
                                119.915635,
                                29.375194
                            ],
                            [
                                119.918294,
                                29.370572
                            ],
                            [
                                119.921264,
                                29.368746
                            ],
                            [
                                119.924731,
                                29.369393
                            ],
                            [
                                119.928494,
                                29.371496
                            ],
                            [
                                119.932941,
                                29.379724
                            ],
                            [
                                119.934854,
                                29.381665
                            ],
                            [
                                119.939503,
                                29.38215
                            ],
                            [
                                119.944028,
                                29.383445
                            ],
                            [
                                119.946578,
                                29.382913
                            ],
                            [
                                119.94919,
                                29.379631
                            ],
                            [
                                119.954648,
                                29.375888
                            ],
                            [
                                119.957664,
                                29.36744
                            ],
                            [
                                119.958955,
                                29.365892
                            ],
                            [
                                119.965688,
                                29.364147
                            ],
                            [
                                119.969342,
                                29.36172
                            ],
                            [
                                119.974395,
                                29.360714
                            ],
                            [
                                119.975017,
                                29.358935
                            ],
                            [
                                119.971721,
                                29.356496
                            ],
                            [
                                119.970228,
                                29.350301
                            ],
                            [
                                119.973618,
                                29.347145
                            ],
                            [
                                119.975639,
                                29.347018
                            ],
                            [
                                119.978298,
                                29.350729
                            ],
                            [
                                119.979635,
                                29.362251
                            ],
                            [
                                119.981641,
                                29.367221
                            ],
                            [
                                119.986446,
                                29.368931
                            ],
                            [
                                119.989649,
                                29.366909
                            ],
                            [
                                119.994049,
                                29.367799
                            ],
                            [
                                119.997206,
                                29.369798
                            ],
                            [
                                119.999072,
                                29.372537
                            ],
                            [
                                119.998994,
                                29.377875
                            ],
                            [
                                120.001513,
                                29.381758
                            ],
                            [
                                120.009816,
                                29.387096
                            ],
                            [
                                120.015943,
                                29.393924
                            ],
                            [
                                120.019177,
                                29.398591
                            ],
                            [
                                120.023282,
                                29.40223
                            ],
                            [
                                120.026905,
                                29.407082
                            ],
                            [
                                120.033171,
                                29.410467
                            ],
                            [
                                120.036483,
                                29.412962
                            ],
                            [
                                120.03978,
                                29.419915
                            ],
                            [
                                120.044538,
                                29.424524
                            ],
                            [
                                120.046513,
                                29.428393
                            ],
                            [
                                120.048487,
                                29.428185
                            ],
                            [
                                120.054116,
                                29.429663
                            ],
                            [
                                120.05917,
                                29.428612
                            ],
                            [
                                120.062031,
                                29.430634
                            ],
                            [
                                120.064301,
                                29.434144
                            ],
                            [
                                120.067302,
                                29.435149
                            ],
                            [
                                120.070178,
                                29.443418
                            ],
                            [
                                120.072791,
                                29.455115
                            ],
                            [
                                120.074874,
                                29.459548
                            ],
                            [
                                120.076973,
                                29.462273
                            ],
                            [
                                120.08097,
                                29.470078
                            ],
                            [
                                120.086583,
                                29.476808
                            ],
                            [
                                120.086287,
                                29.479428
                            ],
                            [
                                120.088293,
                                29.478713
                            ],
                            [
                                120.091201,
                                29.481541
                            ],
                            [
                                120.098074,
                                29.482776
                            ],
                            [
                                120.106439,
                                29.488848
                            ],
                            [
                                120.114509,
                                29.490798
                            ],
                            [
                                120.118303,
                                29.49418
                            ],
                            [
                                120.11863,
                                29.495784
                            ],
                            [
                                120.114229,
                                29.497516
                            ],
                            [
                                120.110777,
                                29.499835
                            ],
                            [
                                120.106144,
                                29.504279
                            ],
                            [
                                120.102909,
                                29.50661
                            ],
                            [
                                120.099224,
                                29.506217
                            ],
                            [
                                120.095586,
                                29.503194
                            ],
                            [
                                120.093331,
                                29.500309
                            ],
                            [
                                120.090346,
                                29.500609
                            ],
                            [
                                120.079632,
                                29.504717
                            ],
                            [
                                120.0773,
                                29.506748
                            ],
                            [
                                120.075574,
                                29.513153
                            ],
                            [
                                120.076554,
                                29.514538
                            ],
                            [
                                120.085012,
                                29.514515
                            ],
                            [
                                120.087034,
                                29.516546
                            ],
                            [
                                120.086645,
                                29.522592
                            ],
                            [
                                120.09173,
                                29.53225
                            ],
                            [
                                120.091792,
                                29.533484
                            ],
                            [
                                120.087314,
                                29.536807
                            ],
                            [
                                120.08467,
                                29.537395
                            ],
                            [
                                120.073615,
                                29.53766
                            ],
                            [
                                120.070209,
                                29.538099
                            ],
                            [
                                120.066929,
                                29.539806
                            ],
                            [
                                120.058765,
                                29.542656
                            ],
                            [
                                120.05564,
                                29.546347
                            ],
                            [
                                120.0511,
                                29.549347
                            ],
                            [
                                120.052235,
                                29.553995
                            ],
                            [
                                120.054691,
                                29.558194
                            ],
                            [
                                120.052981,
                                29.559394
                            ],
                            [
                                120.047057,
                                29.56117
                            ],
                            [
                                120.04446,
                                29.563604
                            ],
                            [
                                120.042065,
                                29.569601
                            ],
                            [
                                120.040168,
                                29.570155
                            ],
                            [
                                120.03143,
                                29.565807
                            ],
                            [
                                120.026314,
                                29.568275
                            ],
                            [
                                120.020981,
                                29.568667
                            ],
                            [
                                120.007873,
                                29.572162
                            ],
                            [
                                120.006427,
                                29.573638
                            ],
                            [
                                120.00624,
                                29.579392
                            ],
                            [
                                120.008184,
                                29.582575
                            ],
                            [
                                120.006458,
                                29.592596
                            ],
                            [
                                120.007329,
                                29.596032
                            ],
                            [
                                120.011713,
                                29.604829
                            ],
                            [
                                120.017156,
                                29.609568
                            ],
                            [
                                120.019239,
                                29.617879
                            ],
                            [
                                120.020996,
                                29.619171
                            ],
                            [
                                120.028087,
                                29.619274
                            ],
                            [
                                120.033436,
                                29.617395
                            ],
                            [
                                120.035084,
                                29.617441
                            ],
                            [
                                120.040215,
                                29.619839
                            ],
                            [
                                120.042952,
                                29.622871
                            ],
                            [
                                120.045984,
                                29.628335
                            ],
                            [
                                120.0446,
                                29.631597
                            ],
                            [
                                120.036545,
                                29.635354
                            ],
                            [
                                120.03342,
                                29.635585
                            ],
                            [
                                120.031725,
                                29.636806
                            ],
                            [
                                120.029066,
                                29.641416
                            ],
                            [
                                120.024231,
                                29.643721
                            ],
                            [
                                120.024728,
                                29.647905
                            ],
                            [
                                120.030108,
                                29.649219
                            ],
                            [
                                120.03342,
                                29.650694
                            ],
                            [
                                120.036701,
                                29.653851
                            ],
                            [
                                120.037789,
                                29.661526
                            ],
                            [
                                120.037199,
                                29.663991
                            ],
                            [
                                120.033233,
                                29.667851
                            ],
                            [
                                120.03045,
                                29.668865
                            ],
                            [
                                120.029486,
                                29.667828
                            ],
                            [
                                120.030761,
                                29.663531
                            ],
                            [
                                120.029548,
                                29.66027
                            ],
                            [
                                120.029082,
                                29.653275
                            ],
                            [
                                120.021696,
                                29.647974
                            ],
                            [
                                120.014559,
                                29.64855
                            ],
                            [
                                120.01106,
                                29.650094
                            ],
                            [
                                120.002602,
                                29.655096
                            ],
                            [
                                119.997859,
                                29.655176
                            ],
                            [
                                119.99108,
                                29.654347
                            ],
                            [
                                119.988841,
                                29.661168
                            ],
                            [
                                119.984393,
                                29.665489
                            ],
                            [
                                119.979029,
                                29.668266
                            ],
                            [
                                119.973105,
                                29.674822
                            ],
                            [
                                119.973167,
                                29.673094
                            ],
                            [
                                119.970772,
                                29.670755
                            ],
                            [
                                119.966823,
                                29.670951
                            ],
                            [
                                119.959079,
                                29.672829
                            ],
                            [
                                119.948864,
                                29.668013
                            ],
                            [
                                119.94566,
                                29.667367
                            ],
                            [
                                119.940716,
                                29.667506
                            ],
                            [
                                119.936175,
                                29.666526
                            ],
                            [
                                119.924809,
                                29.669891
                            ],
                            [
                                119.922803,
                                29.668485
                            ],
                            [
                                119.921264,
                                29.664026
                            ],
                            [
                                119.918247,
                                29.664383
                            ],
                            [
                                119.914531,
                                29.66625
                            ],
                            [
                                119.911701,
                                29.666492
                            ],
                            [
                                119.908591,
                                29.663081
                            ],
                            [
                                119.902356,
                                29.661399
                            ],
                            [
                                119.895716,
                                29.66065
                            ],
                            [
                                119.887164,
                                29.662044
                            ],
                            [
                                119.88351,
                                29.663438
                            ],
                            [
                                119.879281,
                                29.667932
                            ],
                            [
                                119.875813,
                                29.668981
                            ],
                            [
                                119.873061,
                                29.668669
                            ],
                            [
                                119.869998,
                                29.669948
                            ],
                            [
                                119.86339,
                                29.669487
                            ],
                            [
                                119.859549,
                                29.671342
                            ],
                            [
                                119.856532,
                                29.671031
                            ],
                            [
                                119.852521,
                                29.668877
                            ],
                            [
                                119.842165,
                                29.675548
                            ],
                            [
                                119.837656,
                                29.676446
                            ],
                            [
                                119.835448,
                                29.678129
                            ],
                            [
                                119.836909,
                                29.680755
                            ],
                            [
                                119.835354,
                                29.682253
                            ],
                            [
                                119.82447,
                                29.671861
                            ],
                            [
                                119.821733,
                                29.671193
                            ],
                            [
                                119.817613,
                                29.673059
                            ],
                            [
                                119.81413,
                                29.671366
                            ],
                            [
                                119.810693,
                                29.667494
                            ],
                            [
                                119.809962,
                                29.665201
                            ],
                            [
                                119.805329,
                                29.664959
                            ],
                            [
                                119.802483,
                                29.663254
                            ],
                            [
                                119.799187,
                                29.660074
                            ],
                            [
                                119.798254,
                                29.656939
                            ],
                            [
                                119.796357,
                                29.655683
                            ],
                            [
                                119.7932,
                                29.65611
                            ],
                            [
                                119.791179,
                                29.654969
                            ],
                            [
                                119.788163,
                                29.645208
                            ],
                            [
                                119.781057,
                                29.638616
                            ],
                            [
                                119.777511,
                                29.628646
                            ],
                            [
                                119.776516,
                                29.626848
                            ],
                            [
                                119.776205,
                                29.620243
                            ],
                            [
                                119.779813,
                                29.61328
                            ],
                            [
                                119.780077,
                                29.609464
                            ],
                            [
                                119.779315,
                                29.603999
                            ],
                            [
                                119.773982,
                                29.598914
                            ],
                            [
                                119.76728,
                                29.597658
                            ],
                            [
                                119.764963,
                                29.594683
                            ],
                            [
                                119.766456,
                                29.592504
                            ],
                            [
                                119.766829,
                                29.589344
                            ],
                            [
                                119.765243,
                                29.58758
                            ],
                            [
                                119.765616,
                                29.584709
                            ],
                            [
                                119.768415,
                                29.58246
                            ],
                            [
                                119.769177,
                                29.579542
                            ],
                            [
                                119.766176,
                                29.570904
                            ],
                            [
                                119.761636,
                                29.566522
                            ],
                            [
                                119.764823,
                                29.563119
                            ],
                            [
                                119.765523,
                                29.560017
                            ],
                            [
                                119.764186,
                                29.557329
                            ],
                            [
                                119.758837,
                                29.556026
                            ],
                            [
                                119.756411,
                                29.553719
                            ],
                            [
                                119.750673,
                                29.550719
                            ],
                            [
                                119.748232,
                                29.550466
                            ],
                            [
                                119.741095,
                                29.551908
                            ],
                            [
                                119.730397,
                                29.548205
                            ],
                            [
                                119.724815,
                                29.545125
                            ],
                            [
                                119.722623,
                                29.542771
                            ],
                            [
                                119.724753,
                                29.538191
                            ],
                            [
                                119.731874,
                                29.532965
                            ],
                            [
                                119.7343,
                                29.528384
                            ],
                            [
                                119.744034,
                                29.520792
                            ],
                            [
                                119.745604,
                                29.51838
                            ],
                            [
                                119.744936,
                                29.51643
                            ],
                            [
                                119.740349,
                                29.513349
                            ],
                            [
                                119.735404,
                                29.510926
                            ],
                            [
                                119.726883,
                                29.511561
                            ],
                            [
                                119.727521,
                                29.509437
                            ],
                            [
                                119.725546,
                                29.506921
                            ],
                            [
                                119.718844,
                                29.505283
                            ],
                            [
                                119.717849,
                                29.502651
                            ],
                            [
                                119.718331,
                                29.496685
                            ],
                            [
                                119.719559,
                                29.491156
                            ],
                            [
                                119.718735,
                                29.488536
                            ],
                            [
                                119.716667,
                                29.486331
                            ],
                            [
                                119.71264,
                                29.484138
                            ],
                            [
                                119.706794,
                                29.472375
                            ],
                            [
                                119.708457,
                                29.467723
                            ],
                            [
                                119.70712,
                                29.464224
                            ],
                            [
                                119.709515,
                                29.45889
                            ],
                            [
                                119.713433,
                                29.456189
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 330727,
                "name": "磐安县",
                "center": [
                    120.44513,
                    29.052627
                ],
                "centroid": [
                    120.559672,
                    29.037893
                ],
                "childrenNum": 0,
                "level": "district",
                "parent": {
                    "adcode": 330700
                },
                "subFeatureIndex": 4,
                "acroutes": [
                    100000,
                    330000,
                    330700
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                120.307941,
                                28.933833
                            ],
                            [
                                120.308237,
                                28.931779
                            ],
                            [
                                120.306526,
                                28.926858
                            ],
                            [
                                120.314285,
                                28.919105
                            ],
                            [
                                120.31385,
                                28.913406
                            ],
                            [
                                120.310134,
                                28.909761
                            ],
                            [
                                120.30791,
                                28.906314
                            ],
                            [
                                120.30833,
                                28.901949
                            ],
                            [
                                120.308097,
                                28.8959
                            ],
                            [
                                120.304303,
                                28.893729
                            ],
                            [
                                120.303432,
                                28.892046
                            ],
                            [
                                120.312435,
                                28.887437
                            ],
                            [
                                120.316571,
                                28.886276
                            ],
                            [
                                120.318157,
                                28.880737
                            ],
                            [
                                120.316353,
                                28.876581
                            ],
                            [
                                120.322215,
                                28.872447
                            ],
                            [
                                120.327284,
                                28.870101
                            ],
                            [
                                120.331389,
                                28.868917
                            ],
                            [
                                120.335665,
                                28.86505
                            ],
                            [
                                120.33593,
                                28.862309
                            ],
                            [
                                120.338293,
                                28.860253
                            ],
                            [
                                120.347265,
                                28.858256
                            ],
                            [
                                120.348478,
                                28.851009
                            ],
                            [
                                120.351899,
                                28.849998
                            ],
                            [
                                120.355693,
                                28.84584
                            ],
                            [
                                120.357885,
                                28.841879
                            ],
                            [
                                120.357932,
                                28.83937
                            ],
                            [
                                120.364867,
                                28.838999
                            ],
                            [
                                120.368443,
                                28.838035
                            ],
                            [
                                120.373885,
                                28.83383
                            ],
                            [
                                120.376389,
                                28.832958
                            ],
                            [
                                120.381302,
                                28.833992
                            ],
                            [
                                120.384272,
                                28.830995
                            ],
                            [
                                120.388455,
                                28.829462
                            ],
                            [
                                120.390756,
                                28.83074
                            ],
                            [
                                120.392855,
                                28.834561
                            ],
                            [
                                120.394255,
                                28.842205
                            ],
                            [
                                120.392389,
                                28.844237
                            ],
                            [
                                120.392964,
                                28.847141
                            ],
                            [
                                120.396416,
                                28.849162
                            ],
                            [
                                120.399044,
                                28.854226
                            ],
                            [
                                120.402232,
                                28.855852
                            ],
                            [
                                120.404782,
                                28.853285
                            ],
                            [
                                120.404704,
                                28.848686
                            ],
                            [
                                120.406896,
                                28.84519
                            ],
                            [
                                120.41139,
                                28.845875
                            ],
                            [
                                120.415573,
                                28.848001
                            ],
                            [
                                120.418092,
                                28.851648
                            ],
                            [
                                120.422523,
                                28.846851
                            ],
                            [
                                120.424716,
                                28.836745
                            ],
                            [
                                120.426706,
                                28.831994
                            ],
                            [
                                120.430174,
                                28.832819
                            ],
                            [
                                120.433594,
                                28.836954
                            ],
                            [
                                120.436906,
                                28.838197
                            ],
                            [
                                120.441773,
                                28.841415
                            ],
                            [
                                120.449361,
                                28.842449
                            ],
                            [
                                120.463449,
                                28.839428
                            ],
                            [
                                120.467212,
                                28.841763
                            ],
                            [
                                120.46942,
                                28.841484
                            ],
                            [
                                120.473898,
                                28.839196
                            ],
                            [
                                120.476697,
                                28.833992
                            ],
                            [
                                120.476541,
                                28.82995
                            ],
                            [
                                120.481128,
                                28.828184
                            ],
                            [
                                120.484565,
                                28.832854
                            ],
                            [
                                120.482434,
                                28.836397
                            ],
                            [
                                120.484471,
                                28.838511
                            ],
                            [
                                120.487643,
                                28.840102
                            ],
                            [
                                120.485871,
                                28.844435
                            ],
                            [
                                120.486788,
                                28.846014
                            ],
                            [
                                120.493443,
                                28.847896
                            ],
                            [
                                120.496693,
                                28.847199
                            ],
                            [
                                120.498466,
                                28.849197
                            ],
                            [
                                120.495853,
                                28.853041
                            ],
                            [
                                120.501731,
                                28.856189
                            ],
                            [
                                120.502229,
                                28.857211
                            ],
                            [
                                120.494952,
                                28.866002
                            ],
                            [
                                120.494905,
                                28.868591
                            ],
                            [
                                120.497859,
                                28.871216
                            ],
                            [
                                120.504592,
                                28.87218
                            ],
                            [
                                120.509988,
                                28.874874
                            ],
                            [
                                120.511605,
                                28.880865
                            ],
                            [
                                120.510501,
                                28.883733
                            ],
                            [
                                120.513626,
                                28.887924
                            ],
                            [
                                120.514699,
                                28.890722
                            ],
                            [
                                120.520172,
                                28.887692
                            ],
                            [
                                120.517747,
                                28.884476
                            ],
                            [
                                120.518275,
                                28.883106
                            ],
                            [
                                120.522925,
                                28.879449
                            ],
                            [
                                120.525475,
                                28.878647
                            ],
                            [
                                120.532565,
                                28.879878
                            ],
                            [
                                120.536281,
                                28.877382
                            ],
                            [
                                120.534291,
                                28.875361
                            ],
                            [
                                120.531679,
                                28.874386
                            ],
                            [
                                120.531228,
                                28.871936
                            ],
                            [
                                120.533576,
                                28.866304
                            ],
                            [
                                120.53751,
                                28.864933
                            ],
                            [
                                120.542765,
                                28.867047
                            ],
                            [
                                120.545409,
                                28.866722
                            ],
                            [
                                120.553432,
                                28.861844
                            ],
                            [
                                120.563259,
                                28.861705
                            ],
                            [
                                120.568282,
                                28.864063
                            ],
                            [
                                120.571951,
                                28.867895
                            ],
                            [
                                120.579959,
                                28.869346
                            ],
                            [
                                120.582105,
                                28.870856
                            ],
                            [
                                120.586878,
                                28.875837
                            ],
                            [
                                120.58736,
                                28.877916
                            ],
                            [
                                120.59005,
                                28.881109
                            ],
                            [
                                120.594529,
                                28.883675
                            ],
                            [
                                120.599209,
                                28.885312
                            ],
                            [
                                120.60448,
                                28.890699
                            ],
                            [
                                120.606424,
                                28.890397
                            ],
                            [
                                120.612472,
                                28.892336
                            ],
                            [
                                120.619065,
                                28.895622
                            ],
                            [
                                120.624741,
                                28.896005
                            ],
                            [
                                120.630276,
                                28.897027
                            ],
                            [
                                120.636885,
                                28.898861
                            ],
                            [
                                120.642436,
                                28.899395
                            ],
                            [
                                120.646976,
                                28.900486
                            ],
                            [
                                120.651703,
                                28.905652
                            ],
                            [
                                120.657052,
                                28.908287
                            ],
                            [
                                120.659462,
                                28.913441
                            ],
                            [
                                120.663785,
                                28.916493
                            ],
                            [
                                120.664935,
                                28.923771
                            ],
                            [
                                120.663925,
                                28.926626
                            ],
                            [
                                120.662276,
                                28.927682
                            ],
                            [
                                120.660146,
                                28.93157
                            ],
                            [
                                120.659618,
                                28.93714
                            ],
                            [
                                120.661048,
                                28.941144
                            ],
                            [
                                120.664018,
                                28.946482
                            ],
                            [
                                120.669103,
                                28.949046
                            ],
                            [
                                120.672352,
                                28.956066
                            ],
                            [
                                120.673425,
                                28.959907
                            ],
                            [
                                120.672819,
                                28.970511
                            ],
                            [
                                120.673332,
                                28.973156
                            ],
                            [
                                120.677686,
                                28.977297
                            ],
                            [
                                120.686782,
                                28.97826
                            ],
                            [
                                120.692893,
                                28.980626
                            ],
                            [
                                120.696671,
                                28.980023
                            ],
                            [
                                120.696842,
                                28.977401
                            ],
                            [
                                120.698864,
                                28.972993
                            ],
                            [
                                120.70314,
                                28.973666
                            ],
                            [
                                120.714708,
                                28.973109
                            ],
                            [
                                120.717305,
                                28.973759
                            ],
                            [
                                120.719078,
                                28.976671
                            ],
                            [
                                120.719047,
                                28.979431
                            ],
                            [
                                120.726666,
                                28.981264
                            ],
                            [
                                120.728951,
                                28.983804
                            ],
                            [
                                120.728563,
                                28.987168
                            ],
                            [
                                120.724473,
                                28.992411
                            ],
                            [
                                120.722996,
                                28.992295
                            ],
                            [
                                120.722017,
                                28.995229
                            ],
                            [
                                120.725748,
                                28.995624
                            ],
                            [
                                120.729527,
                                28.997132
                            ],
                            [
                                120.728081,
                                29.003267
                            ],
                            [
                                120.728267,
                                29.009819
                            ],
                            [
                                120.72651,
                                29.013344
                            ],
                            [
                                120.72522,
                                29.013518
                            ],
                            [
                                120.721861,
                                29.010654
                            ],
                            [
                                120.720291,
                                29.011593
                            ],
                            [
                                120.721721,
                                29.018284
                            ],
                            [
                                120.724738,
                                29.022841
                            ],
                            [
                                120.724131,
                                29.024186
                            ],
                            [
                                120.720166,
                                29.025079
                            ],
                            [
                                120.717103,
                                29.027502
                            ],
                            [
                                120.716046,
                                29.03323
                            ],
                            [
                                120.713573,
                                29.035271
                            ],
                            [
                                120.710324,
                                29.034818
                            ],
                            [
                                120.708489,
                                29.032685
                            ],
                            [
                                120.707478,
                                29.024986
                            ],
                            [
                                120.70429,
                                29.022064
                            ],
                            [
                                120.70174,
                                29.022725
                            ],
                            [
                                120.696531,
                                29.02872
                            ],
                            [
                                120.695132,
                                29.031062
                            ],
                            [
                                120.693157,
                                29.040012
                            ],
                            [
                                120.693857,
                                29.041253
                            ],
                            [
                                120.698195,
                                29.040696
                            ],
                            [
                                120.700714,
                                29.044348
                            ],
                            [
                                120.697666,
                                29.045589
                            ],
                            [
                                120.693701,
                                29.048811
                            ],
                            [
                                120.691602,
                                29.052103
                            ],
                            [
                                120.698693,
                                29.056323
                            ],
                            [
                                120.702036,
                                29.059823
                            ],
                            [
                                120.702051,
                                29.06417
                            ],
                            [
                                120.70513,
                                29.070255
                            ],
                            [
                                120.704866,
                                29.075887
                            ],
                            [
                                120.700885,
                                29.080755
                            ],
                            [
                                120.697915,
                                29.082342
                            ],
                            [
                                120.69437,
                                29.086931
                            ],
                            [
                                120.695365,
                                29.091485
                            ],
                            [
                                120.701212,
                                29.097441
                            ],
                            [
                                120.709857,
                                29.098426
                            ],
                            [
                                120.714429,
                                29.104196
                            ],
                            [
                                120.719513,
                                29.109352
                            ],
                            [
                                120.720399,
                                29.112329
                            ],
                            [
                                120.723618,
                                29.119129
                            ],
                            [
                                120.725297,
                                29.119604
                            ],
                            [
                                120.729667,
                                29.11548
                            ],
                            [
                                120.732497,
                                29.114113
                            ],
                            [
                                120.736617,
                                29.113325
                            ],
                            [
                                120.739851,
                                29.113569
                            ],
                            [
                                120.744376,
                                29.11592
                            ],
                            [
                                120.746164,
                                29.118851
                            ],
                            [
                                120.746849,
                                29.122906
                            ],
                            [
                                120.745263,
                                29.123821
                            ],
                            [
                                120.73982,
                                29.12389
                            ],
                            [
                                120.738359,
                                29.124516
                            ],
                            [
                                120.734409,
                                29.131269
                            ],
                            [
                                120.732528,
                                29.132694
                            ],
                            [
                                120.726432,
                                29.134002
                            ],
                            [
                                120.722156,
                                29.13025
                            ],
                            [
                                120.720306,
                                29.130887
                            ],
                            [
                                120.718736,
                                29.135659
                            ],
                            [
                                120.712485,
                                29.143546
                            ],
                            [
                                120.712314,
                                29.145469
                            ],
                            [
                                120.71404,
                                29.14987
                            ],
                            [
                                120.720026,
                                29.150877
                            ],
                            [
                                120.723618,
                                29.15713
                            ],
                            [
                                120.731113,
                                29.164507
                            ],
                            [
                                120.738794,
                                29.167888
                            ],
                            [
                                120.741733,
                                29.169694
                            ],
                            [
                                120.744594,
                                29.172728
                            ],
                            [
                                120.752944,
                                29.178829
                            ],
                            [
                                120.755105,
                                29.181619
                            ],
                            [
                                120.757189,
                                29.186331
                            ],
                            [
                                120.759879,
                                29.189006
                            ],
                            [
                                120.766705,
                                29.192293
                            ],
                            [
                                120.775708,
                                29.197456
                            ],
                            [
                                120.777885,
                                29.200454
                            ],
                            [
                                120.773189,
                                29.205709
                            ],
                            [
                                120.773484,
                                29.207133
                            ],
                            [
                                120.776967,
                                29.209853
                            ],
                            [
                                120.776423,
                                29.213232
                            ],
                            [
                                120.777652,
                                29.215234
                            ],
                            [
                                120.783,
                                29.219077
                            ],
                            [
                                120.783078,
                                29.221206
                            ],
                            [
                                120.776548,
                                29.225095
                            ],
                            [
                                120.773173,
                                29.231841
                            ],
                            [
                                120.775848,
                                29.237928
                            ],
                            [
                                120.776563,
                                29.242105
                            ],
                            [
                                120.776034,
                                29.245842
                            ],
                            [
                                120.77238,
                                29.262872
                            ],
                            [
                                120.772287,
                                29.266828
                            ],
                            [
                                120.774822,
                                29.271108
                            ],
                            [
                                120.775723,
                                29.275688
                            ],
                            [
                                120.774791,
                                29.277076
                            ],
                            [
                                120.762833,
                                29.279505
                            ],
                            [
                                120.758837,
                                29.281356
                            ],
                            [
                                120.757158,
                                29.2836
                            ],
                            [
                                120.756769,
                                29.286294
                            ],
                            [
                                120.763953,
                                29.293881
                            ],
                            [
                                120.766938,
                                29.297616
                            ],
                            [
                                120.772225,
                                29.301999
                            ],
                            [
                                120.773002,
                                29.304647
                            ],
                            [
                                120.765414,
                                29.311111
                            ],
                            [
                                120.761434,
                                29.3134
                            ],
                            [
                                120.756707,
                                29.313863
                            ],
                            [
                                120.754561,
                                29.315528
                            ],
                            [
                                120.749912,
                                29.315921
                            ],
                            [
                                120.742402,
                                29.310729
                            ],
                            [
                                120.73514,
                                29.309365
                            ],
                            [
                                120.72906,
                                29.310163
                            ],
                            [
                                120.734689,
                                29.306451
                            ],
                            [
                                120.737053,
                                29.300542
                            ],
                            [
                                120.731906,
                                29.291476
                            ],
                            [
                                120.728905,
                                29.283507
                            ],
                            [
                                120.722436,
                                29.278048
                            ],
                            [
                                120.720275,
                                29.274948
                            ],
                            [
                                120.71886,
                                29.269673
                            ],
                            [
                                120.719249,
                                29.265717
                            ],
                            [
                                120.717119,
                                29.262467
                            ],
                            [
                                120.709717,
                                29.259008
                            ],
                            [
                                120.706949,
                                29.2591
                            ],
                            [
                                120.701818,
                                29.263068
                            ],
                            [
                                120.696469,
                                29.264977
                            ],
                            [
                                120.695925,
                                29.262374
                            ],
                            [
                                120.693748,
                                29.261426
                            ],
                            [
                                120.690312,
                                29.262201
                            ],
                            [
                                120.689348,
                                29.260604
                            ],
                            [
                                120.68658,
                                29.264653
                            ],
                            [
                                120.68927,
                                29.266435
                            ],
                            [
                                120.687342,
                                29.269789
                            ],
                            [
                                120.681713,
                                29.270391
                            ],
                            [
                                120.677437,
                                29.274127
                            ],
                            [
                                120.672352,
                                29.276197
                            ],
                            [
                                120.668496,
                                29.276521
                            ],
                            [
                                120.664951,
                                29.275931
                            ],
                            [
                                120.657332,
                                29.271432
                            ],
                            [
                                120.65276,
                                29.268181
                            ],
                            [
                                120.650444,
                                29.26574
                            ],
                            [
                                120.644364,
                                29.261148
                            ],
                            [
                                120.64455,
                                29.259066
                            ],
                            [
                                120.640041,
                                29.254588
                            ],
                            [
                                120.636496,
                                29.250123
                            ],
                            [
                                120.632951,
                                29.246895
                            ],
                            [
                                120.633231,
                                29.242984
                            ],
                            [
                                120.630649,
                                29.238541
                            ],
                            [
                                120.626482,
                                29.235961
                            ],
                            [
                                120.619703,
                                29.236123
                            ],
                            [
                                120.616142,
                                29.235579
                            ],
                            [
                                120.605973,
                                29.23051
                            ],
                            [
                                120.601946,
                                29.229527
                            ],
                            [
                                120.601028,
                                29.228254
                            ],
                            [
                                120.602505,
                                29.223104
                            ],
                            [
                                120.600468,
                                29.21594
                            ],
                            [
                                120.593658,
                                29.207017
                            ],
                            [
                                120.587252,
                                29.201496
                            ],
                            [
                                120.579057,
                                29.197502
                            ],
                            [
                                120.569168,
                                29.193393
                            ],
                            [
                                120.56301,
                                29.19124
                            ],
                            [
                                120.55945,
                                29.186713
                            ],
                            [
                                120.559403,
                                29.182071
                            ],
                            [
                                120.554785,
                                29.176051
                            ],
                            [
                                120.553214,
                                29.170759
                            ],
                            [
                                120.551768,
                                29.168258
                            ],
                            [
                                120.54205,
                                29.158798
                            ],
                            [
                                120.537681,
                                29.156447
                            ],
                            [
                                120.530264,
                                29.155509
                            ],
                            [
                                120.521992,
                                29.155579
                            ],
                            [
                                120.51571,
                                29.160871
                            ],
                            [
                                120.511247,
                                29.161959
                            ],
                            [
                                120.506598,
                                29.161867
                            ],
                            [
                                120.500223,
                                29.157107
                            ],
                            [
                                120.49066,
                                29.152093
                            ],
                            [
                                120.478656,
                                29.151329
                            ],
                            [
                                120.475437,
                                29.1487
                            ],
                            [
                                120.473198,
                                29.145781
                            ],
                            [
                                120.471037,
                                29.140222
                            ],
                            [
                                120.471721,
                                29.136122
                            ],
                            [
                                120.47354,
                                29.132497
                            ],
                            [
                                120.477054,
                                29.130574
                            ],
                            [
                                120.48996,
                                29.129149
                            ],
                            [
                                120.492992,
                                29.127458
                            ],
                            [
                                120.49803,
                                29.116395
                            ],
                            [
                                120.49817,
                                29.108738
                            ],
                            [
                                120.494889,
                                29.104578
                            ],
                            [
                                120.49136,
                                29.095738
                            ],
                            [
                                120.490784,
                                29.089724
                            ],
                            [
                                120.493925,
                                29.087766
                            ],
                            [
                                120.492075,
                                29.077799
                            ],
                            [
                                120.496024,
                                29.07219
                            ],
                            [
                                120.494718,
                                29.068597
                            ],
                            [
                                120.49307,
                                29.067137
                            ],
                            [
                                120.486866,
                                29.067995
                            ],
                            [
                                120.483741,
                                29.069119
                            ],
                            [
                                120.483787,
                                29.07525
                            ],
                            [
                                120.480242,
                                29.078031
                            ],
                            [
                                120.479636,
                                29.085089
                            ],
                            [
                                120.473447,
                                29.085042
                            ],
                            [
                                120.465159,
                                29.089376
                            ],
                            [
                                120.46177,
                                29.089782
                            ],
                            [
                                120.454353,
                                29.088461
                            ],
                            [
                                120.453109,
                                29.087476
                            ],
                            [
                                120.451429,
                                29.080905
                            ],
                            [
                                120.448319,
                                29.078298
                            ],
                            [
                                120.443872,
                                29.077846
                            ],
                            [
                                120.437342,
                                29.078333
                            ],
                            [
                                120.42823,
                                29.076131
                            ],
                            [
                                120.422508,
                                29.073697
                            ],
                            [
                                120.417034,
                                29.072086
                            ],
                            [
                                120.41366,
                                29.069548
                            ],
                            [
                                120.410504,
                                29.063011
                            ],
                            [
                                120.408949,
                                29.060948
                            ],
                            [
                                120.406539,
                                29.049414
                            ],
                            [
                                120.407658,
                                29.047722
                            ],
                            [
                                120.412199,
                                29.04385
                            ],
                            [
                                120.411686,
                                29.03956
                            ],
                            [
                                120.406383,
                                29.034413
                            ],
                            [
                                120.404595,
                                29.0317
                            ],
                            [
                                120.404859,
                                29.030088
                            ],
                            [
                                120.408856,
                                29.027468
                            ],
                            [
                                120.406368,
                                29.021635
                            ],
                            [
                                120.403367,
                                29.01796
                            ],
                            [
                                120.397645,
                                29.014075
                            ],
                            [
                                120.395048,
                                29.011605
                            ],
                            [
                                120.394224,
                                29.008451
                            ],
                            [
                                120.394752,
                                29.00518
                            ],
                            [
                                120.393664,
                                29.001968
                            ],
                            [
                                120.390321,
                                29.000912
                            ],
                            [
                                120.386092,
                                28.997306
                            ],
                            [
                                120.380634,
                                28.996494
                            ],
                            [
                                120.377135,
                                28.994139
                            ],
                            [
                                120.374585,
                                28.995427
                            ],
                            [
                                120.371211,
                                28.993084
                            ],
                            [
                                120.370884,
                                28.98994
                            ],
                            [
                                120.373217,
                                28.982888
                            ],
                            [
                                120.37684,
                                28.98421
                            ],
                            [
                                120.379126,
                                28.981972
                            ],
                            [
                                120.377882,
                                28.978596
                            ],
                            [
                                120.376047,
                                28.977425
                            ],
                            [
                                120.374927,
                                28.974258
                            ],
                            [
                                120.370869,
                                28.970696
                            ],
                            [
                                120.370107,
                                28.968364
                            ],
                            [
                                120.367417,
                                28.968295
                            ],
                            [
                                120.364634,
                                28.966148
                            ],
                            [
                                120.361477,
                                28.967668
                            ],
                            [
                                120.357683,
                                28.971346
                            ],
                            [
                                120.35633,
                                28.971705
                            ],
                            [
                                120.353112,
                                28.96949
                            ],
                            [
                                120.351417,
                                28.969687
                            ],
                            [
                                120.349364,
                                28.971961
                            ],
                            [
                                120.346099,
                                28.965522
                            ],
                            [
                                120.348696,
                                28.962633
                            ],
                            [
                                120.347141,
                                28.961148
                            ],
                            [
                                120.342336,
                                28.961194
                            ],
                            [
                                120.33394,
                                28.957865
                            ],
                            [
                                120.328964,
                                28.95544
                            ],
                            [
                                120.322418,
                                28.951112
                            ],
                            [
                                120.316416,
                                28.946308
                            ],
                            [
                                120.315965,
                                28.943917
                            ],
                            [
                                120.312451,
                                28.941585
                            ],
                            [
                                120.310631,
                                28.939253
                            ],
                            [
                                120.307941,
                                28.933833
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 330781,
                "name": "兰溪市",
                "center": [
                    119.460521,
                    29.210065
                ],
                "centroid": [
                    119.526736,
                    29.278165
                ],
                "childrenNum": 0,
                "level": "district",
                "parent": {
                    "adcode": 330700
                },
                "subFeatureIndex": 5,
                "acroutes": [
                    100000,
                    330000,
                    330700
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                119.322977,
                                29.088403
                            ],
                            [
                                119.32562,
                                29.091775
                            ],
                            [
                                119.33027,
                                29.095993
                            ],
                            [
                                119.343486,
                                29.106837
                            ],
                            [
                                119.348866,
                                29.108958
                            ],
                            [
                                119.354915,
                                29.113754
                            ],
                            [
                                119.35731,
                                29.12294
                            ],
                            [
                                119.360808,
                                29.1263
                            ],
                            [
                                119.368458,
                                29.127991
                            ],
                            [
                                119.375891,
                                29.127551
                            ],
                            [
                                119.381318,
                                29.124968
                            ],
                            [
                                119.385671,
                                29.125014
                            ],
                            [
                                119.389248,
                                29.128906
                            ],
                            [
                                119.391238,
                                29.132983
                            ],
                            [
                                119.394643,
                                29.138288
                            ],
                            [
                                119.40049,
                                29.146337
                            ],
                            [
                                119.4029,
                                29.14621
                            ],
                            [
                                119.404408,
                                29.144762
                            ],
                            [
                                119.404299,
                                29.137176
                            ],
                            [
                                119.406787,
                                29.137153
                            ],
                            [
                                119.409773,
                                29.140778
                            ],
                            [
                                119.412245,
                                29.140697
                            ],
                            [
                                119.412385,
                                29.136168
                            ],
                            [
                                119.413753,
                                29.136203
                            ],
                            [
                                119.419988,
                                29.140361
                            ],
                            [
                                119.424886,
                                29.141149
                            ],
                            [
                                119.428805,
                                29.142793
                            ],
                            [
                                119.431277,
                                29.142388
                            ],
                            [
                                119.439021,
                                29.138392
                            ],
                            [
                                119.441353,
                                29.132531
                            ],
                            [
                                119.444914,
                                29.129763
                            ],
                            [
                                119.446562,
                                29.131246
                            ],
                            [
                                119.450076,
                                29.130203
                            ],
                            [
                                119.450652,
                                29.12791
                            ],
                            [
                                119.448879,
                                29.123844
                            ],
                            [
                                119.445925,
                                29.121909
                            ],
                            [
                                119.447371,
                                29.114785
                            ],
                            [
                                119.449967,
                                29.114507
                            ],
                            [
                                119.452922,
                                29.11212
                            ],
                            [
                                119.453995,
                                29.113545
                            ],
                            [
                                119.451647,
                                29.117635
                            ],
                            [
                                119.452129,
                                29.119581
                            ],
                            [
                                119.454928,
                                29.11943
                            ],
                            [
                                119.456047,
                                29.11592
                            ],
                            [
                                119.456171,
                                29.111842
                            ],
                            [
                                119.458022,
                                29.109525
                            ],
                            [
                                119.460945,
                                29.109201
                            ],
                            [
                                119.464863,
                                29.105297
                            ],
                            [
                                119.467958,
                                29.099863
                            ],
                            [
                                119.473167,
                                29.096572
                            ],
                            [
                                119.477521,
                                29.095819
                            ],
                            [
                                119.479278,
                                29.096305
                            ],
                            [
                                119.490349,
                                29.110707
                            ],
                            [
                                119.496195,
                                29.111078
                            ],
                            [
                                119.498605,
                                29.109224
                            ],
                            [
                                119.500611,
                                29.109502
                            ],
                            [
                                119.502446,
                                29.111669
                            ],
                            [
                                119.501155,
                                29.115978
                            ],
                            [
                                119.500393,
                                29.121261
                            ],
                            [
                                119.501715,
                                29.124168
                            ],
                            [
                                119.499974,
                                29.13003
                            ],
                            [
                                119.504545,
                                29.133551
                            ],
                            [
                                119.520219,
                                29.132369
                            ],
                            [
                                119.539733,
                                29.131674
                            ],
                            [
                                119.541988,
                                29.133365
                            ],
                            [
                                119.54502,
                                29.138624
                            ],
                            [
                                119.54617,
                                29.138948
                            ],
                            [
                                119.546497,
                                29.135647
                            ],
                            [
                                119.545268,
                                29.12996
                            ],
                            [
                                119.547912,
                                29.129856
                            ],
                            [
                                119.551379,
                                29.133493
                            ],
                            [
                                119.556433,
                                29.141786
                            ],
                            [
                                119.557024,
                                29.143442
                            ],
                            [
                                119.555733,
                                29.148387
                            ],
                            [
                                119.560693,
                                29.15185
                            ],
                            [
                                119.563445,
                                29.15544
                            ],
                            [
                                119.564581,
                                29.160547
                            ],
                            [
                                119.561937,
                                29.165259
                            ],
                            [
                                119.562201,
                                29.167946
                            ],
                            [
                                119.565249,
                                29.177394
                            ],
                            [
                                119.566446,
                                29.183981
                            ],
                            [
                                119.567628,
                                29.185648
                            ],
                            [
                                119.573257,
                                29.189689
                            ],
                            [
                                119.578217,
                                29.192305
                            ],
                            [
                                119.58254,
                                29.197271
                            ],
                            [
                                119.589366,
                                29.206299
                            ],
                            [
                                119.594933,
                                29.211774
                            ],
                            [
                                119.598711,
                                29.221901
                            ],
                            [
                                119.599317,
                                29.225453
                            ],
                            [
                                119.601074,
                                29.22602
                            ],
                            [
                                119.607792,
                                29.223474
                            ],
                            [
                                119.623745,
                                29.225303
                            ],
                            [
                                119.631069,
                                29.223104
                            ],
                            [
                                119.635376,
                                29.223428
                            ],
                            [
                                119.642684,
                                29.222317
                            ],
                            [
                                119.645763,
                                29.223
                            ],
                            [
                                119.655932,
                                29.22727
                            ],
                            [
                                119.661623,
                                29.226634
                            ],
                            [
                                119.667796,
                                29.230742
                            ],
                            [
                                119.676628,
                                29.230765
                            ],
                            [
                                119.681479,
                                29.233797
                            ],
                            [
                                119.701071,
                                29.237638
                            ],
                            [
                                119.708069,
                                29.239374
                            ],
                            [
                                119.710059,
                                29.240739
                            ],
                            [
                                119.714024,
                                29.246883
                            ],
                            [
                                119.719591,
                                29.249047
                            ],
                            [
                                119.724115,
                                29.25224
                            ],
                            [
                                119.733274,
                                29.253003
                            ],
                            [
                                119.742572,
                                29.255364
                            ],
                            [
                                119.744734,
                                29.256451
                            ],
                            [
                                119.747564,
                                29.261588
                            ],
                            [
                                119.748061,
                                29.26537
                            ],
                            [
                                119.755012,
                                29.270495
                            ],
                            [
                                119.759723,
                                29.272762
                            ],
                            [
                                119.768602,
                                29.28235
                            ],
                            [
                                119.771167,
                                29.28456
                            ],
                            [
                                119.776127,
                                29.28471
                            ],
                            [
                                119.780792,
                                29.288804
                            ],
                            [
                                119.785706,
                                29.291233
                            ],
                            [
                                119.7895,
                                29.294251
                            ],
                            [
                                119.799296,
                                29.297512
                            ],
                            [
                                119.80253,
                                29.301155
                            ],
                            [
                                119.807754,
                                29.302149
                            ],
                            [
                                119.813041,
                                29.304462
                            ],
                            [
                                119.819712,
                                29.306752
                            ],
                            [
                                119.820287,
                                29.315528
                            ],
                            [
                                119.821484,
                                29.318557
                            ],
                            [
                                119.827129,
                                29.324523
                            ],
                            [
                                119.830596,
                                29.325933
                            ],
                            [
                                119.838231,
                                29.326326
                            ],
                            [
                                119.840781,
                                29.328037
                            ],
                            [
                                119.844217,
                                29.332303
                            ],
                            [
                                119.848633,
                                29.331297
                            ],
                            [
                                119.850468,
                                29.332199
                            ],
                            [
                                119.85123,
                                29.337413
                            ],
                            [
                                119.855024,
                                29.340187
                            ],
                            [
                                119.855708,
                                29.342476
                            ],
                            [
                                119.867448,
                                29.342788
                            ],
                            [
                                119.872159,
                                29.344013
                            ],
                            [
                                119.879545,
                                29.346995
                            ],
                            [
                                119.882888,
                                29.357629
                            ],
                            [
                                119.884288,
                                29.360888
                            ],
                            [
                                119.888019,
                                29.362529
                            ],
                            [
                                119.893306,
                                29.361627
                            ],
                            [
                                119.896851,
                                29.363846
                            ],
                            [
                                119.899106,
                                29.369208
                            ],
                            [
                                119.89553,
                                29.370618
                            ],
                            [
                                119.894566,
                                29.372282
                            ],
                            [
                                119.894084,
                                29.378522
                            ],
                            [
                                119.889683,
                                29.382925
                            ],
                            [
                                119.890103,
                                29.385501
                            ],
                            [
                                119.892529,
                                29.38824
                            ],
                            [
                                119.890305,
                                29.394213
                            ],
                            [
                                119.890865,
                                29.401433
                            ],
                            [
                                119.885345,
                                29.405014
                            ],
                            [
                                119.882049,
                                29.409624
                            ],
                            [
                                119.878985,
                                29.410167
                            ],
                            [
                                119.874849,
                                29.407671
                            ],
                            [
                                119.871615,
                                29.404599
                            ],
                            [
                                119.868427,
                                29.405373
                            ],
                            [
                                119.865069,
                                29.409751
                            ],
                            [
                                119.856657,
                                29.410109
                            ],
                            [
                                119.849893,
                                29.413597
                            ],
                            [
                                119.844342,
                                29.413932
                            ],
                            [
                                119.840968,
                                29.416242
                            ],
                            [
                                119.839133,
                                29.415688
                            ],
                            [
                                119.835588,
                                29.412615
                            ],
                            [
                                119.834064,
                                29.408676
                            ],
                            [
                                119.829943,
                                29.408422
                            ],
                            [
                                119.822915,
                                29.41146
                            ],
                            [
                                119.820225,
                                29.409531
                            ],
                            [
                                119.818888,
                                29.4029
                            ],
                            [
                                119.814239,
                                29.400752
                            ],
                            [
                                119.81329,
                                29.39687
                            ],
                            [
                                119.814752,
                                29.391012
                            ],
                            [
                                119.807941,
                                29.387904
                            ],
                            [
                                119.804443,
                                29.389418
                            ],
                            [
                                119.802685,
                                29.391382
                            ],
                            [
                                119.802312,
                                29.394929
                            ],
                            [
                                119.799653,
                                29.396558
                            ],
                            [
                                119.795937,
                                29.397159
                            ],
                            [
                                119.786234,
                                29.401352
                            ],
                            [
                                119.781585,
                                29.400625
                            ],
                            [
                                119.775459,
                                29.402011
                            ],
                            [
                                119.769923,
                                29.406019
                            ],
                            [
                                119.765912,
                                29.407336
                            ],
                            [
                                119.761993,
                                29.413262
                            ],
                            [
                                119.755618,
                                29.416508
                            ],
                            [
                                119.752026,
                                29.416577
                            ],
                            [
                                119.749212,
                                29.417744
                            ],
                            [
                                119.744531,
                                29.42114
                            ],
                            [
                                119.745262,
                                29.423773
                            ],
                            [
                                119.748357,
                                29.426915
                            ],
                            [
                                119.748496,
                                29.429201
                            ],
                            [
                                119.743847,
                                29.437828
                            ],
                            [
                                119.741826,
                                29.439676
                            ],
                            [
                                119.738623,
                                29.440311
                            ],
                            [
                                119.736368,
                                29.445947
                            ],
                            [
                                119.733771,
                                29.450207
                            ],
                            [
                                119.727769,
                                29.453429
                            ],
                            [
                                119.723898,
                                29.453914
                            ],
                            [
                                119.713433,
                                29.456189
                            ],
                            [
                                119.715812,
                                29.449007
                            ],
                            [
                                119.713433,
                                29.445011
                            ],
                            [
                                119.710665,
                                29.442263
                            ],
                            [
                                119.70953,
                                29.43911
                            ],
                            [
                                119.710619,
                                29.436131
                            ],
                            [
                                119.709639,
                                29.434179
                            ],
                            [
                                119.707276,
                                29.433221
                            ],
                            [
                                119.700512,
                                29.433013
                            ],
                            [
                                119.697386,
                                29.43411
                            ],
                            [
                                119.69367,
                                29.438764
                            ],
                            [
                                119.691167,
                                29.438775
                            ],
                            [
                                119.689829,
                                29.433336
                            ],
                            [
                                119.690327,
                                29.426857
                            ],
                            [
                                119.688912,
                                29.421752
                            ],
                            [
                                119.683439,
                                29.418622
                            ],
                            [
                                119.678992,
                                29.417779
                            ],
                            [
                                119.676317,
                                29.419211
                            ],
                            [
                                119.673394,
                                29.425021
                            ],
                            [
                                119.670051,
                                29.425425
                            ],
                            [
                                119.664406,
                                29.424062
                            ],
                            [
                                119.660099,
                                29.426892
                            ],
                            [
                                119.655497,
                                29.425921
                            ],
                            [
                                119.64909,
                                29.428347
                            ],
                            [
                                119.646758,
                                29.433232
                            ],
                            [
                                119.644472,
                                29.434098
                            ],
                            [
                                119.642498,
                                29.432955
                            ],
                            [
                                119.638657,
                                29.428266
                            ],
                            [
                                119.633603,
                                29.423357
                            ],
                            [
                                119.626637,
                                29.420216
                            ],
                            [
                                119.624927,
                                29.417767
                            ],
                            [
                                119.625627,
                                29.415295
                            ],
                            [
                                119.625533,
                                29.410478
                            ],
                            [
                                119.61737,
                                29.399735
                            ],
                            [
                                119.612161,
                                29.394767
                            ],
                            [
                                119.607061,
                                29.393878
                            ],
                            [
                                119.605553,
                                29.392734
                            ],
                            [
                                119.606237,
                                29.388078
                            ],
                            [
                                119.613871,
                                29.383237
                            ],
                            [
                                119.617588,
                                29.380359
                            ],
                            [
                                119.618567,
                                29.378464
                            ],
                            [
                                119.619656,
                                29.372953
                            ],
                            [
                                119.619376,
                                29.371057
                            ],
                            [
                                119.616282,
                                29.368261
                            ],
                            [
                                119.614058,
                                29.368284
                            ],
                            [
                                119.608507,
                                29.370248
                            ],
                            [
                                119.604589,
                                29.369636
                            ],
                            [
                                119.597996,
                                29.372929
                            ],
                            [
                                119.592927,
                                29.377702
                            ],
                            [
                                119.589459,
                                29.378696
                            ],
                            [
                                119.582073,
                                29.379135
                            ],
                            [
                                119.578419,
                                29.378129
                            ],
                            [
                                119.574594,
                                29.372756
                            ],
                            [
                                119.565902,
                                29.371184
                            ],
                            [
                                119.560569,
                                29.372086
                            ],
                            [
                                119.556775,
                                29.371589
                            ],
                            [
                                119.551473,
                                29.367325
                            ],
                            [
                                119.545408,
                                29.367359
                            ],
                            [
                                119.540915,
                                29.369798
                            ],
                            [
                                119.538831,
                                29.371936
                            ],
                            [
                                119.536048,
                                29.373149
                            ],
                            [
                                119.529844,
                                29.370549
                            ],
                            [
                                119.523888,
                                29.365996
                            ],
                            [
                                119.52577,
                                29.363476
                            ],
                            [
                                119.526594,
                                29.360021
                            ],
                            [
                                119.52507,
                                29.355155
                            ],
                            [
                                119.522707,
                                29.350012
                            ],
                            [
                                119.512086,
                                29.336731
                            ],
                            [
                                119.510423,
                                29.333471
                            ],
                            [
                                119.501995,
                                29.335875
                            ],
                            [
                                119.500036,
                                29.335713
                            ],
                            [
                                119.492339,
                                29.331066
                            ],
                            [
                                119.485357,
                                29.332546
                            ],
                            [
                                119.480211,
                                29.332974
                            ],
                            [
                                119.477552,
                                29.335054
                            ],
                            [
                                119.477707,
                                29.341597
                            ],
                            [
                                119.476028,
                                29.345215
                            ],
                            [
                                119.471472,
                                29.349018
                            ],
                            [
                                119.469653,
                                29.349665
                            ],
                            [
                                119.464552,
                                29.34918
                            ],
                            [
                                119.461427,
                                29.350913
                            ],
                            [
                                119.459826,
                                29.356658
                            ],
                            [
                                119.454834,
                                29.365279
                            ],
                            [
                                119.457586,
                                29.370364
                            ],
                            [
                                119.453373,
                                29.378823
                            ],
                            [
                                119.451833,
                                29.385594
                            ],
                            [
                                119.453606,
                                29.389256
                            ],
                            [
                                119.451351,
                                29.397286
                            ],
                            [
                                119.448879,
                                29.400682
                            ],
                            [
                                119.443141,
                                29.404564
                            ],
                            [
                                119.440669,
                                29.408746
                            ],
                            [
                                119.44168,
                                29.413043
                            ],
                            [
                                119.438803,
                                29.415757
                            ],
                            [
                                119.439425,
                                29.421429
                            ],
                            [
                                119.438974,
                                29.4236
                            ],
                            [
                                119.437139,
                                29.424131
                            ],
                            [
                                119.427779,
                                29.422156
                            ],
                            [
                                119.428556,
                                29.419061
                            ],
                            [
                                119.432335,
                                29.415145
                            ],
                            [
                                119.426752,
                                29.405546
                            ],
                            [
                                119.421248,
                                29.40476
                            ],
                            [
                                119.415883,
                                29.402993
                            ],
                            [
                                119.410721,
                                29.402554
                            ],
                            [
                                119.409213,
                                29.400717
                            ],
                            [
                                119.405605,
                                29.399931
                            ],
                            [
                                119.40475,
                                29.400682
                            ],
                            [
                                119.404906,
                                29.405326
                            ],
                            [
                                119.403988,
                                29.407221
                            ],
                            [
                                119.399946,
                                29.411241
                            ],
                            [
                                119.393524,
                                29.411252
                            ],
                            [
                                119.391704,
                                29.416878
                            ],
                            [
                                119.389776,
                                29.425829
                            ],
                            [
                                119.388548,
                                29.429721
                            ],
                            [
                                119.382126,
                                29.431858
                            ],
                            [
                                119.378114,
                                29.429802
                            ],
                            [
                                119.375285,
                                29.424535
                            ],
                            [
                                119.372455,
                                29.421036
                            ],
                            [
                                119.370806,
                                29.417709
                            ],
                            [
                                119.368303,
                                29.415699
                            ],
                            [
                                119.362161,
                                29.416739
                            ],
                            [
                                119.360233,
                                29.416289
                            ],
                            [
                                119.355568,
                                29.41079
                            ],
                            [
                                119.353205,
                                29.409878
                            ],
                            [
                                119.346394,
                                29.408723
                            ],
                            [
                                119.343906,
                                29.409011
                            ],
                            [
                                119.338386,
                                29.411714
                            ],
                            [
                                119.334903,
                                29.408157
                            ],
                            [
                                119.334048,
                                29.405349
                            ],
                            [
                                119.331094,
                                29.400359
                            ],
                            [
                                119.327797,
                                29.396928
                            ],
                            [
                                119.328637,
                                29.393427
                            ],
                            [
                                119.333877,
                                29.390735
                            ],
                            [
                                119.336038,
                                29.385848
                            ],
                            [
                                119.339117,
                                29.3843
                            ],
                            [
                                119.340159,
                                29.382358
                            ],
                            [
                                119.339304,
                                29.379146
                            ],
                            [
                                119.340206,
                                29.377309
                            ],
                            [
                                119.336474,
                                29.37249
                            ],
                            [
                                119.335012,
                                29.36699
                            ],
                            [
                                119.336707,
                                29.363372
                            ],
                            [
                                119.333084,
                                29.355063
                            ],
                            [
                                119.333395,
                                29.350821
                            ],
                            [
                                119.335961,
                                29.348359
                            ],
                            [
                                119.340003,
                                29.348579
                            ],
                            [
                                119.34557,
                                29.342268
                            ],
                            [
                                119.348447,
                                29.336245
                            ],
                            [
                                119.348229,
                                29.333436
                            ],
                            [
                                119.344279,
                                29.324384
                            ],
                            [
                                119.347094,
                                29.322719
                            ],
                            [
                                119.348789,
                                29.319505
                            ],
                            [
                                119.34728,
                                29.317158
                            ],
                            [
                                119.340532,
                                29.315389
                            ],
                            [
                                119.32419,
                                29.307989
                            ],
                            [
                                119.323132,
                                29.305006
                            ],
                            [
                                119.328637,
                                29.29927
                            ],
                            [
                                119.329026,
                                29.29439
                            ],
                            [
                                119.328326,
                                29.292782
                            ],
                            [
                                119.325776,
                                29.292239
                            ],
                            [
                                119.32419,
                                29.295408
                            ],
                            [
                                119.322619,
                                29.296171
                            ],
                            [
                                119.322604,
                                29.290493
                            ],
                            [
                                119.32335,
                                29.288145
                            ],
                            [
                                119.322713,
                                29.28493
                            ],
                            [
                                119.318297,
                                29.279898
                            ],
                            [
                                119.312668,
                                29.278638
                            ],
                            [
                                119.30508,
                                29.27932
                            ],
                            [
                                119.298643,
                                29.279274
                            ],
                            [
                                119.292563,
                                29.281795
                            ],
                            [
                                119.288116,
                                29.280997
                            ],
                            [
                                119.286017,
                                29.279332
                            ],
                            [
                                119.286203,
                                29.27526
                            ],
                            [
                                119.2881,
                                29.268841
                            ],
                            [
                                119.287167,
                                29.267464
                            ],
                            [
                                119.282331,
                                29.264942
                            ],
                            [
                                119.282052,
                                29.261264
                            ],
                            [
                                119.278646,
                                29.26065
                            ],
                            [
                                119.27577,
                                29.258638
                            ],
                            [
                                119.273484,
                                29.253767
                            ],
                            [
                                119.270654,
                                29.25165
                            ],
                            [
                                119.26092,
                                29.247809
                            ],
                            [
                                119.256333,
                                29.244893
                            ],
                            [
                                119.253503,
                                29.241457
                            ],
                            [
                                119.251731,
                                29.236875
                            ],
                            [
                                119.249973,
                                29.234236
                            ],
                            [
                                119.244936,
                                29.228636
                            ],
                            [
                                119.241997,
                                29.227085
                            ],
                            [
                                119.234937,
                                29.221935
                            ],
                            [
                                119.233491,
                                29.216947
                            ],
                            [
                                119.235917,
                                29.213684
                            ],
                            [
                                119.234004,
                                29.210813
                            ],
                            [
                                119.234533,
                                29.206045
                            ],
                            [
                                119.233336,
                                29.195847
                            ],
                            [
                                119.228702,
                                29.19477
                            ],
                            [
                                119.232154,
                                29.192872
                            ],
                            [
                                119.23797,
                                29.191714
                            ],
                            [
                                119.242152,
                                29.1897
                            ],
                            [
                                119.243832,
                                29.183148
                            ],
                            [
                                119.241344,
                                29.17656
                            ],
                            [
                                119.244733,
                                29.171975
                            ],
                            [
                                119.241468,
                                29.168884
                            ],
                            [
                                119.24153,
                                29.165723
                            ],
                            [
                                119.245884,
                                29.160327
                            ],
                            [
                                119.247315,
                                29.157455
                            ],
                            [
                                119.253332,
                                29.154757
                            ],
                            [
                                119.253394,
                                29.151989
                            ],
                            [
                                119.251746,
                                29.148607
                            ],
                            [
                                119.251093,
                                29.14167
                            ],
                            [
                                119.252912,
                                29.139724
                            ],
                            [
                                119.256706,
                                29.13823
                            ],
                            [
                                119.264994,
                                29.136562
                            ],
                            [
                                119.267155,
                                29.13391
                            ],
                            [
                                119.267917,
                                29.124956
                            ],
                            [
                                119.267715,
                                29.119106
                            ],
                            [
                                119.275552,
                                29.118759
                            ],
                            [
                                119.2837,
                                29.117658
                            ],
                            [
                                119.285208,
                                29.114681
                            ],
                            [
                                119.286903,
                                29.113708
                            ],
                            [
                                119.292532,
                                29.105911
                            ],
                            [
                                119.294351,
                                29.104694
                            ],
                            [
                                119.297305,
                                29.104671
                            ],
                            [
                                119.298238,
                                29.103362
                            ],
                            [
                                119.302592,
                                29.100905
                            ],
                            [
                                119.300011,
                                29.090697
                            ],
                            [
                                119.302032,
                                29.087429
                            ],
                            [
                                119.30536,
                                29.085599
                            ],
                            [
                                119.312761,
                                29.087105
                            ],
                            [
                                119.318374,
                                29.086294
                            ],
                            [
                                119.322977,
                                29.088403
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 330782,
                "name": "义乌市",
                "center": [
                    120.074911,
                    29.306863
                ],
                "centroid": [
                    120.061011,
                    29.300614
                ],
                "childrenNum": 0,
                "level": "district",
                "parent": {
                    "adcode": 330700
                },
                "subFeatureIndex": 6,
                "acroutes": [
                    100000,
                    330000,
                    330700
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                119.897147,
                                29.050133
                            ],
                            [
                                119.896789,
                                29.047953
                            ],
                            [
                                119.898671,
                                29.046736
                            ],
                            [
                                119.905061,
                                29.04647
                            ],
                            [
                                119.907503,
                                29.050991
                            ],
                            [
                                119.911297,
                                29.053541
                            ],
                            [
                                119.918543,
                                29.05579
                            ],
                            [
                                119.928961,
                                29.053726
                            ],
                            [
                                119.930795,
                                29.054515
                            ],
                            [
                                119.935071,
                                29.059255
                            ],
                            [
                                119.93941,
                                29.061353
                            ],
                            [
                                119.947106,
                                29.060681
                            ],
                            [
                                119.951585,
                                29.057969
                            ],
                            [
                                119.955208,
                                29.053831
                            ],
                            [
                                119.961909,
                                29.050643
                            ],
                            [
                                119.97113,
                                29.043502
                            ],
                            [
                                119.978765,
                                29.034227
                            ],
                            [
                                119.983087,
                                29.034958
                            ],
                            [
                                119.985668,
                                29.039525
                            ],
                            [
                                119.990131,
                                29.050179
                            ],
                            [
                                119.991919,
                                29.051605
                            ],
                            [
                                119.996631,
                                29.052799
                            ],
                            [
                                120.000844,
                                29.055639
                            ],
                            [
                                120.005354,
                                29.054897
                            ],
                            [
                                120.01204,
                                29.057343
                            ],
                            [
                                120.020608,
                                29.061562
                            ],
                            [
                                120.024868,
                                29.064645
                            ],
                            [
                                120.032674,
                                29.061168
                            ],
                            [
                                120.035519,
                                29.061643
                            ],
                            [
                                120.042672,
                                29.065619
                            ],
                            [
                                120.050058,
                                29.068319
                            ],
                            [
                                120.056697,
                                29.068783
                            ],
                            [
                                120.059325,
                                29.068018
                            ],
                            [
                                120.062948,
                                29.070382
                            ],
                            [
                                120.058516,
                                29.072909
                            ],
                            [
                                120.058019,
                                29.074485
                            ],
                            [
                                120.060071,
                                29.077753
                            ],
                            [
                                120.062186,
                                29.076641
                            ],
                            [
                                120.06357,
                                29.078078
                            ],
                            [
                                120.063632,
                                29.080847
                            ],
                            [
                                120.065731,
                                29.082458
                            ],
                            [
                                120.066058,
                                29.085274
                            ],
                            [
                                120.068997,
                                29.087499
                            ],
                            [
                                120.072215,
                                29.094185
                            ],
                            [
                                120.070925,
                                29.100488
                            ],
                            [
                                120.073039,
                                29.101867
                            ],
                            [
                                120.074781,
                                29.099225
                            ],
                            [
                                120.077067,
                                29.098067
                            ],
                            [
                                120.081887,
                                29.098611
                            ],
                            [
                                120.086225,
                                29.09707
                            ],
                            [
                                120.08722,
                                29.098484
                            ],
                            [
                                120.084017,
                                29.104845
                            ],
                            [
                                120.084017,
                                29.106108
                            ],
                            [
                                120.086645,
                                29.110649
                            ],
                            [
                                120.091325,
                                29.112966
                            ],
                            [
                                120.092865,
                                29.115955
                            ],
                            [
                                120.093082,
                                29.121794
                            ],
                            [
                                120.091123,
                                29.129172
                            ],
                            [
                                120.089646,
                                29.131616
                            ],
                            [
                                120.085277,
                                29.136249
                            ],
                            [
                                120.08467,
                                29.137964
                            ],
                            [
                                120.084981,
                                29.144403
                            ],
                            [
                                120.086085,
                                29.149719
                            ],
                            [
                                120.08649,
                                29.155359
                            ],
                            [
                                120.087376,
                                29.157628
                            ],
                            [
                                120.090859,
                                29.159898
                            ],
                            [
                                120.091574,
                                29.162029
                            ],
                            [
                                120.08991,
                                29.167043
                            ],
                            [
                                120.09414,
                                29.170516
                            ],
                            [
                                120.092694,
                                29.17194
                            ],
                            [
                                120.091527,
                                29.177718
                            ],
                            [
                                120.091901,
                                29.179894
                            ],
                            [
                                120.094171,
                                29.181944
                            ],
                            [
                                120.104884,
                                29.188184
                            ],
                            [
                                120.107823,
                                29.195465
                            ],
                            [
                                120.10591,
                                29.199459
                            ],
                            [
                                120.105739,
                                29.204216
                            ],
                            [
                                120.113079,
                                29.207353
                            ],
                            [
                                120.119361,
                                29.212827
                            ],
                            [
                                120.122533,
                                29.216959
                            ],
                            [
                                120.127928,
                                29.226506
                            ],
                            [
                                120.131567,
                                29.228289
                            ],
                            [
                                120.136449,
                                29.234491
                            ],
                            [
                                120.1325,
                                29.238425
                            ],
                            [
                                120.133215,
                                29.239941
                            ],
                            [
                                120.135454,
                                29.239929
                            ],
                            [
                                120.142404,
                                29.242822
                            ],
                            [
                                120.143882,
                                29.242313
                            ],
                            [
                                120.14469,
                                29.239733
                            ],
                            [
                                120.151143,
                                29.238842
                            ],
                            [
                                120.157891,
                                29.245853
                            ],
                            [
                                120.161266,
                                29.247369
                            ],
                            [
                                120.164438,
                                29.251592
                            ],
                            [
                                120.163925,
                                29.254507
                            ],
                            [
                                120.158296,
                                29.259517
                            ],
                            [
                                120.15573,
                                29.260928
                            ],
                            [
                                120.155015,
                                29.262941
                            ],
                            [
                                120.156476,
                                29.265926
                            ],
                            [
                                120.155046,
                                29.269338
                            ],
                            [
                                120.157829,
                                29.272681
                            ],
                            [
                                120.155855,
                                29.276567
                            ],
                            [
                                120.14738,
                                29.281402
                            ],
                            [
                                120.146261,
                                29.283125
                            ],
                            [
                                120.148515,
                                29.286861
                            ],
                            [
                                120.155124,
                                29.291823
                            ],
                            [
                                120.156088,
                                29.294332
                            ],
                            [
                                120.157332,
                                29.301386
                            ],
                            [
                                120.160924,
                                29.301398
                            ],
                            [
                                120.162603,
                                29.303236
                            ],
                            [
                                120.165635,
                                29.308671
                            ],
                            [
                                120.167703,
                                29.309446
                            ],
                            [
                                120.170533,
                                29.306324
                            ],
                            [
                                120.175882,
                                29.305295
                            ],
                            [
                                120.185134,
                                29.304774
                            ],
                            [
                                120.188057,
                                29.305133
                            ],
                            [
                                120.191213,
                                29.303421
                            ],
                            [
                                120.195427,
                                29.302913
                            ],
                            [
                                120.197029,
                                29.306289
                            ],
                            [
                                120.196609,
                                29.309897
                            ],
                            [
                                120.198677,
                                29.313493
                            ],
                            [
                                120.199579,
                                29.311666
                            ],
                            [
                                120.202347,
                                29.31362
                            ],
                            [
                                120.206498,
                                29.325205
                            ],
                            [
                                120.209219,
                                29.326997
                            ],
                            [
                                120.217056,
                                29.327875
                            ],
                            [
                                120.219637,
                                29.331841
                            ],
                            [
                                120.225966,
                                29.336222
                            ],
                            [
                                120.230133,
                                29.339667
                            ],
                            [
                                120.236446,
                                29.343932
                            ],
                            [
                                120.237084,
                                29.355409
                            ],
                            [
                                120.236539,
                                29.359351
                            ],
                            [
                                120.234502,
                                29.36135
                            ],
                            [
                                120.234673,
                                29.364678
                            ],
                            [
                                120.238063,
                                29.366527
                            ],
                            [
                                120.240007,
                                29.368596
                            ],
                            [
                                120.240629,
                                29.372259
                            ],
                            [
                                120.242619,
                                29.37442
                            ],
                            [
                                120.24548,
                                29.379839
                            ],
                            [
                                120.247673,
                                29.385755
                            ],
                            [
                                120.248668,
                                29.39092
                            ],
                            [
                                120.25002,
                                29.393219
                            ],
                            [
                                120.247828,
                                29.397378
                            ],
                            [
                                120.248668,
                                29.401179
                            ],
                            [
                                120.251731,
                                29.402612
                            ],
                            [
                                120.25568,
                                29.402369
                            ],
                            [
                                120.26403,
                                29.400833
                            ],
                            [
                                120.268664,
                                29.403663
                            ],
                            [
                                120.271712,
                                29.408434
                            ],
                            [
                                120.276314,
                                29.413736
                            ],
                            [
                                120.277993,
                                29.416785
                            ],
                            [
                                120.279051,
                                29.426072
                            ],
                            [
                                120.279393,
                                29.433579
                            ],
                            [
                                120.281414,
                                29.436443
                            ],
                            [
                                120.281508,
                                29.440796
                            ],
                            [
                                120.271043,
                                29.450485
                            ],
                            [
                                120.267233,
                                29.452251
                            ],
                            [
                                120.264217,
                                29.455784
                            ],
                            [
                                120.261418,
                                29.460761
                            ],
                            [
                                120.261822,
                                29.469177
                            ],
                            [
                                120.265243,
                                29.476531
                            ],
                            [
                                120.26969,
                                29.481044
                            ],
                            [
                                120.278631,
                                29.483549
                            ],
                            [
                                120.282378,
                                29.486274
                            ],
                            [
                                120.282067,
                                29.48924
                            ],
                            [
                                120.277123,
                                29.496119
                            ],
                            [
                                120.274231,
                                29.498081
                            ],
                            [
                                120.268477,
                                29.498635
                            ],
                            [
                                120.262382,
                                29.495484
                            ],
                            [
                                120.259163,
                                29.495265
                            ],
                            [
                                120.254017,
                                29.496615
                            ],
                            [
                                120.250938,
                                29.49605
                            ],
                            [
                                120.247564,
                                29.498877
                            ],
                            [
                                120.24943,
                                29.504786
                            ],
                            [
                                120.244236,
                                29.510199
                            ],
                            [
                                120.241842,
                                29.511999
                            ],
                            [
                                120.239354,
                                29.511007
                            ],
                            [
                                120.235249,
                                29.511341
                            ],
                            [
                                120.229931,
                                29.512807
                            ],
                            [
                                120.227054,
                                29.514457
                            ],
                            [
                                120.225499,
                                29.518738
                            ],
                            [
                                120.223525,
                                29.522004
                            ],
                            [
                                120.218145,
                                29.523931
                            ],
                            [
                                120.214133,
                                29.524473
                            ],
                            [
                                120.208333,
                                29.52745
                            ],
                            [
                                120.207851,
                                29.528938
                            ],
                            [
                                120.212065,
                                29.534626
                            ],
                            [
                                120.211334,
                                29.537545
                            ],
                            [
                                120.206949,
                                29.546117
                            ],
                            [
                                120.204181,
                                29.548862
                            ],
                            [
                                120.20073,
                                29.549474
                            ],
                            [
                                120.194541,
                                29.547582
                            ],
                            [
                                120.190545,
                                29.547697
                            ],
                            [
                                120.186611,
                                29.549035
                            ],
                            [
                                120.186782,
                                29.545482
                            ],
                            [
                                120.185476,
                                29.541341
                            ],
                            [
                                120.183097,
                                29.537799
                            ],
                            [
                                120.180687,
                                29.535953
                            ],
                            [
                                120.179225,
                                29.532849
                            ],
                            [
                                120.175478,
                                29.5297
                            ],
                            [
                                120.171264,
                                29.5216
                            ],
                            [
                                120.169522,
                                29.519765
                            ],
                            [
                                120.165604,
                                29.518888
                            ],
                            [
                                120.161919,
                                29.514872
                            ],
                            [
                                120.157441,
                                29.512565
                            ],
                            [
                                120.154953,
                                29.512322
                            ],
                            [
                                120.150848,
                                29.510303
                            ],
                            [
                                120.146556,
                                29.50931
                            ],
                            [
                                120.142622,
                                29.509645
                            ],
                            [
                                120.138781,
                                29.508468
                            ],
                            [
                                120.127399,
                                29.494399
                            ],
                            [
                                120.124259,
                                29.494007
                            ],
                            [
                                120.11863,
                                29.495784
                            ],
                            [
                                120.118303,
                                29.49418
                            ],
                            [
                                120.114509,
                                29.490798
                            ],
                            [
                                120.106439,
                                29.488848
                            ],
                            [
                                120.098074,
                                29.482776
                            ],
                            [
                                120.091201,
                                29.481541
                            ],
                            [
                                120.088293,
                                29.478713
                            ],
                            [
                                120.086287,
                                29.479428
                            ],
                            [
                                120.086583,
                                29.476808
                            ],
                            [
                                120.08097,
                                29.470078
                            ],
                            [
                                120.076973,
                                29.462273
                            ],
                            [
                                120.074874,
                                29.459548
                            ],
                            [
                                120.072791,
                                29.455115
                            ],
                            [
                                120.070178,
                                29.443418
                            ],
                            [
                                120.067302,
                                29.435149
                            ],
                            [
                                120.064301,
                                29.434144
                            ],
                            [
                                120.062031,
                                29.430634
                            ],
                            [
                                120.05917,
                                29.428612
                            ],
                            [
                                120.054116,
                                29.429663
                            ],
                            [
                                120.048487,
                                29.428185
                            ],
                            [
                                120.046513,
                                29.428393
                            ],
                            [
                                120.044538,
                                29.424524
                            ],
                            [
                                120.03978,
                                29.419915
                            ],
                            [
                                120.036483,
                                29.412962
                            ],
                            [
                                120.033171,
                                29.410467
                            ],
                            [
                                120.026905,
                                29.407082
                            ],
                            [
                                120.023282,
                                29.40223
                            ],
                            [
                                120.019177,
                                29.398591
                            ],
                            [
                                120.015943,
                                29.393924
                            ],
                            [
                                120.009816,
                                29.387096
                            ],
                            [
                                120.001513,
                                29.381758
                            ],
                            [
                                119.998994,
                                29.377875
                            ],
                            [
                                119.999072,
                                29.372537
                            ],
                            [
                                119.997206,
                                29.369798
                            ],
                            [
                                119.994049,
                                29.367799
                            ],
                            [
                                119.989649,
                                29.366909
                            ],
                            [
                                119.986446,
                                29.368931
                            ],
                            [
                                119.981641,
                                29.367221
                            ],
                            [
                                119.979635,
                                29.362251
                            ],
                            [
                                119.978298,
                                29.350729
                            ],
                            [
                                119.975639,
                                29.347018
                            ],
                            [
                                119.973618,
                                29.347145
                            ],
                            [
                                119.970228,
                                29.350301
                            ],
                            [
                                119.971721,
                                29.356496
                            ],
                            [
                                119.975017,
                                29.358935
                            ],
                            [
                                119.974395,
                                29.360714
                            ],
                            [
                                119.969342,
                                29.36172
                            ],
                            [
                                119.965688,
                                29.364147
                            ],
                            [
                                119.958955,
                                29.365892
                            ],
                            [
                                119.957664,
                                29.36744
                            ],
                            [
                                119.954648,
                                29.375888
                            ],
                            [
                                119.94919,
                                29.379631
                            ],
                            [
                                119.946578,
                                29.382913
                            ],
                            [
                                119.944028,
                                29.383445
                            ],
                            [
                                119.939503,
                                29.38215
                            ],
                            [
                                119.934854,
                                29.381665
                            ],
                            [
                                119.932941,
                                29.379724
                            ],
                            [
                                119.928494,
                                29.371496
                            ],
                            [
                                119.924731,
                                29.369393
                            ],
                            [
                                119.921264,
                                29.368746
                            ],
                            [
                                119.918294,
                                29.370572
                            ],
                            [
                                119.915635,
                                29.375194
                            ],
                            [
                                119.915542,
                                29.383964
                            ],
                            [
                                119.913645,
                                29.386807
                            ],
                            [
                                119.911452,
                                29.388043
                            ],
                            [
                                119.908109,
                                29.387627
                            ],
                            [
                                119.906694,
                                29.385767
                            ],
                            [
                                119.904735,
                                29.37858
                            ],
                            [
                                119.904579,
                                29.374513
                            ],
                            [
                                119.902418,
                                29.371161
                            ],
                            [
                                119.899106,
                                29.369208
                            ],
                            [
                                119.896851,
                                29.363846
                            ],
                            [
                                119.893306,
                                29.361627
                            ],
                            [
                                119.888019,
                                29.362529
                            ],
                            [
                                119.884288,
                                29.360888
                            ],
                            [
                                119.882888,
                                29.357629
                            ],
                            [
                                119.879545,
                                29.346995
                            ],
                            [
                                119.872159,
                                29.344013
                            ],
                            [
                                119.867448,
                                29.342788
                            ],
                            [
                                119.855708,
                                29.342476
                            ],
                            [
                                119.855024,
                                29.340187
                            ],
                            [
                                119.85123,
                                29.337413
                            ],
                            [
                                119.850468,
                                29.332199
                            ],
                            [
                                119.848633,
                                29.331297
                            ],
                            [
                                119.844217,
                                29.332303
                            ],
                            [
                                119.840781,
                                29.328037
                            ],
                            [
                                119.838231,
                                29.326326
                            ],
                            [
                                119.830596,
                                29.325933
                            ],
                            [
                                119.827129,
                                29.324523
                            ],
                            [
                                119.821484,
                                29.318557
                            ],
                            [
                                119.820287,
                                29.315528
                            ],
                            [
                                119.819712,
                                29.306752
                            ],
                            [
                                119.840252,
                                29.298576
                            ],
                            [
                                119.841605,
                                29.295928
                            ],
                            [
                                119.845446,
                                29.295327
                            ],
                            [
                                119.854387,
                                29.286884
                            ],
                            [
                                119.859114,
                                29.284849
                            ],
                            [
                                119.866375,
                                29.285936
                            ],
                            [
                                119.870122,
                                29.282975
                            ],
                            [
                                119.870698,
                                29.280165
                            ],
                            [
                                119.87359,
                                29.274809
                            ],
                            [
                                119.876902,
                                29.272438
                            ],
                            [
                                119.881598,
                                29.272288
                            ],
                            [
                                119.884739,
                                29.273595
                            ],
                            [
                                119.890227,
                                29.273178
                            ],
                            [
                                119.888937,
                                29.272045
                            ],
                            [
                                119.889637,
                                29.26935
                            ],
                            [
                                119.891378,
                                29.267996
                            ],
                            [
                                119.892078,
                                29.263068
                            ],
                            [
                                119.895079,
                                29.263311
                            ],
                            [
                                119.895732,
                                29.265104
                            ],
                            [
                                119.898204,
                                29.263901
                            ],
                            [
                                119.901781,
                                29.259424
                            ],
                            [
                                119.904844,
                                29.257712
                            ],
                            [
                                119.905217,
                                29.251962
                            ],
                            [
                                119.908576,
                                29.252032
                            ],
                            [
                                119.909835,
                                29.250019
                            ],
                            [
                                119.912541,
                                29.250875
                            ],
                            [
                                119.913209,
                                29.248191
                            ],
                            [
                                119.915635,
                                29.248167
                            ],
                            [
                                119.912929,
                                29.244025
                            ],
                            [
                                119.913971,
                                29.239258
                            ],
                            [
                                119.916164,
                                29.236828
                            ],
                            [
                                119.915635,
                                29.235
                            ],
                            [
                                119.912338,
                                29.233218
                            ],
                            [
                                119.913707,
                                29.227259
                            ],
                            [
                                119.912447,
                                29.223486
                            ],
                            [
                                119.911266,
                                29.22521
                            ],
                            [
                                119.910146,
                                29.223775
                            ],
                            [
                                119.911763,
                                29.219655
                            ],
                            [
                                119.910037,
                                29.219135
                            ],
                            [
                                119.913582,
                                29.216114
                            ],
                            [
                                119.914173,
                                29.212816
                            ],
                            [
                                119.91565,
                                29.210512
                            ],
                            [
                                119.91366,
                                29.208024
                            ],
                            [
                                119.911794,
                                29.203417
                            ],
                            [
                                119.911934,
                                29.199979
                            ],
                            [
                                119.915044,
                                29.199077
                            ],
                            [
                                119.91506,
                                29.197224
                            ],
                            [
                                119.917765,
                                29.197745
                            ],
                            [
                                119.918869,
                                29.195465
                            ],
                            [
                                119.920517,
                                29.195106
                            ],
                            [
                                119.923487,
                                29.196993
                            ],
                            [
                                119.923674,
                                29.198417
                            ],
                            [
                                119.926146,
                                29.199551
                            ],
                            [
                                119.929629,
                                29.192143
                            ],
                            [
                                119.926861,
                                29.187883
                            ],
                            [
                                119.926986,
                                29.183993
                            ],
                            [
                                119.931091,
                                29.180543
                            ],
                            [
                                119.932957,
                                29.176085
                            ],
                            [
                                119.93871,
                                29.172079
                            ],
                            [
                                119.939239,
                                29.163233
                            ],
                            [
                                119.938757,
                                29.160257
                            ],
                            [
                                119.939705,
                                29.15119
                            ],
                            [
                                119.941866,
                                29.148642
                            ],
                            [
                                119.946795,
                                29.147078
                            ],
                            [
                                119.948615,
                                29.145446
                            ],
                            [
                                119.949003,
                                29.142122
                            ],
                            [
                                119.948428,
                                29.137257
                            ],
                            [
                                119.94706,
                                29.134118
                            ],
                            [
                                119.944261,
                                29.13113
                            ],
                            [
                                119.943561,
                                29.128906
                            ],
                            [
                                119.943732,
                                29.121342
                            ],
                            [
                                119.943141,
                                29.118249
                            ],
                            [
                                119.940032,
                                29.11577
                            ],
                            [
                                119.933299,
                                29.113789
                            ],
                            [
                                119.921792,
                                29.1119
                            ],
                            [
                                119.918978,
                                29.110707
                            ],
                            [
                                119.917718,
                                29.108251
                            ],
                            [
                                119.918185,
                                29.101543
                            ],
                            [
                                119.915417,
                                29.097951
                            ],
                            [
                                119.916521,
                                29.096514
                            ],
                            [
                                119.92243,
                                29.094417
                            ],
                            [
                                119.921108,
                                29.091497
                            ],
                            [
                                119.918294,
                                29.089226
                            ],
                            [
                                119.916614,
                                29.083895
                            ],
                            [
                                119.912432,
                                29.08393
                            ],
                            [
                                119.90814,
                                29.08298
                            ],
                            [
                                119.906414,
                                29.080233
                            ],
                            [
                                119.906507,
                                29.075702
                            ],
                            [
                                119.909617,
                                29.072295
                            ],
                            [
                                119.914173,
                                29.071993
                            ],
                            [
                                119.916055,
                                29.070139
                            ],
                            [
                                119.911841,
                                29.065468
                            ],
                            [
                                119.902356,
                                29.059452
                            ],
                            [
                                119.900505,
                                29.057563
                            ],
                            [
                                119.901532,
                                29.054468
                            ],
                            [
                                119.901065,
                                29.052637
                            ],
                            [
                                119.897147,
                                29.050133
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 330783,
                "name": "东阳市",
                "center": [
                    120.23334,
                    29.262546
                ],
                "centroid": [
                    120.375678,
                    29.232405
                ],
                "childrenNum": 0,
                "level": "district",
                "parent": {
                    "adcode": 330700
                },
                "subFeatureIndex": 7,
                "acroutes": [
                    100000,
                    330000,
                    330700
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                120.077067,
                                29.098067
                            ],
                            [
                                120.078824,
                                29.096363
                            ],
                            [
                                120.081109,
                                29.097823
                            ],
                            [
                                120.084484,
                                29.093617
                            ],
                            [
                                120.088324,
                                29.094591
                            ],
                            [
                                120.090657,
                                29.092459
                            ],
                            [
                                120.093347,
                                29.093107
                            ],
                            [
                                120.094933,
                                29.091114
                            ],
                            [
                                120.100235,
                                29.08955
                            ],
                            [
                                120.104791,
                                29.092065
                            ],
                            [
                                120.10661,
                                29.096804
                            ],
                            [
                                120.109565,
                                29.099422
                            ],
                            [
                                120.114167,
                                29.101624
                            ],
                            [
                                120.116981,
                                29.095599
                            ],
                            [
                                120.12233,
                                29.0905
                            ],
                            [
                                120.125969,
                                29.0878
                            ],
                            [
                                120.129701,
                                29.086746
                            ],
                            [
                                120.139668,
                                29.095042
                            ],
                            [
                                120.141767,
                                29.09568
                            ],
                            [
                                120.144504,
                                29.094602
                            ],
                            [
                                120.149277,
                                29.094452
                            ],
                            [
                                120.153398,
                                29.091532
                            ],
                            [
                                120.159415,
                                29.091543
                            ],
                            [
                                120.163785,
                                29.088287
                            ],
                            [
                                120.16775,
                                29.088171
                            ],
                            [
                                120.172492,
                                29.093049
                            ],
                            [
                                120.173705,
                                29.093571
                            ],
                            [
                                120.1754,
                                29.091427
                            ],
                            [
                                120.174203,
                                29.089353
                            ],
                            [
                                120.168356,
                                29.085181
                            ],
                            [
                                120.15772,
                                29.076733
                            ],
                            [
                                120.157549,
                                29.074844
                            ],
                            [
                                120.164158,
                                29.077533
                            ],
                            [
                                120.167376,
                                29.074705
                            ],
                            [
                                120.171559,
                                29.073465
                            ],
                            [
                                120.170564,
                                29.070579
                            ],
                            [
                                120.173223,
                                29.068725
                            ],
                            [
                                120.180655,
                                29.066685
                            ],
                            [
                                120.184496,
                                29.066697
                            ],
                            [
                                120.191416,
                                29.062002
                            ],
                            [
                                120.197791,
                                29.060612
                            ],
                            [
                                120.203637,
                                29.062686
                            ],
                            [
                                120.206871,
                                29.065677
                            ],
                            [
                                120.21009,
                                29.066615
                            ],
                            [
                                120.215579,
                                29.065642
                            ],
                            [
                                120.220073,
                                29.06636
                            ],
                            [
                                120.228096,
                                29.062756
                            ],
                            [
                                120.235498,
                                29.061006
                            ],
                            [
                                120.238887,
                                29.054572
                            ],
                            [
                                120.242153,
                                29.053309
                            ],
                            [
                                120.240038,
                                29.048313
                            ],
                            [
                                120.241671,
                                29.039096
                            ],
                            [
                                120.243754,
                                29.033474
                            ],
                            [
                                120.246071,
                                29.031375
                            ],
                            [
                                120.257515,
                                29.026726
                            ],
                            [
                                120.261574,
                                29.025902
                            ],
                            [
                                120.266814,
                                29.026934
                            ],
                            [
                                120.274837,
                                29.025485
                            ],
                            [
                                120.276734,
                                29.023954
                            ],
                            [
                                120.278118,
                                29.018041
                            ],
                            [
                                120.280248,
                                29.015084
                            ],
                            [
                                120.285768,
                                29.009947
                            ],
                            [
                                120.287789,
                                29.008868
                            ],
                            [
                                120.290464,
                                29.009123
                            ],
                            [
                                120.295409,
                                29.011014
                            ],
                            [
                                120.299374,
                                29.010828
                            ],
                            [
                                120.306946,
                                29.008926
                            ],
                            [
                                120.309247,
                                29.01048
                            ],
                            [
                                120.312062,
                                29.009634
                            ],
                            [
                                120.319681,
                                29.009796
                            ],
                            [
                                120.322184,
                                29.006711
                            ],
                            [
                                120.322122,
                                29.003023
                            ],
                            [
                                120.318484,
                                28.997201
                            ],
                            [
                                120.316245,
                                28.996807
                            ],
                            [
                                120.313788,
                                28.994452
                            ],
                            [
                                120.317768,
                                28.988398
                            ],
                            [
                                120.321889,
                                28.986878
                            ],
                            [
                                120.322169,
                                28.98486
                            ],
                            [
                                120.325636,
                                28.984245
                            ],
                            [
                                120.326429,
                                28.981438
                            ],
                            [
                                120.322713,
                                28.979014
                            ],
                            [
                                120.321593,
                                28.974756
                            ],
                            [
                                120.322464,
                                28.971404
                            ],
                            [
                                120.324486,
                                28.968921
                            ],
                            [
                                120.328902,
                                28.96681
                            ],
                            [
                                120.330612,
                                28.967274
                            ],
                            [
                                120.339584,
                                28.974211
                            ],
                            [
                                120.340937,
                                28.977726
                            ],
                            [
                                120.343129,
                                28.978689
                            ],
                            [
                                120.345415,
                                28.982123
                            ],
                            [
                                120.347467,
                                28.982552
                            ],
                            [
                                120.348525,
                                28.979884
                            ],
                            [
                                120.349364,
                                28.971961
                            ],
                            [
                                120.351417,
                                28.969687
                            ],
                            [
                                120.353112,
                                28.96949
                            ],
                            [
                                120.35633,
                                28.971705
                            ],
                            [
                                120.357683,
                                28.971346
                            ],
                            [
                                120.361477,
                                28.967668
                            ],
                            [
                                120.364634,
                                28.966148
                            ],
                            [
                                120.367417,
                                28.968295
                            ],
                            [
                                120.370107,
                                28.968364
                            ],
                            [
                                120.370869,
                                28.970696
                            ],
                            [
                                120.374927,
                                28.974258
                            ],
                            [
                                120.376047,
                                28.977425
                            ],
                            [
                                120.377882,
                                28.978596
                            ],
                            [
                                120.379126,
                                28.981972
                            ],
                            [
                                120.37684,
                                28.98421
                            ],
                            [
                                120.373217,
                                28.982888
                            ],
                            [
                                120.370884,
                                28.98994
                            ],
                            [
                                120.371211,
                                28.993084
                            ],
                            [
                                120.374585,
                                28.995427
                            ],
                            [
                                120.377135,
                                28.994139
                            ],
                            [
                                120.380634,
                                28.996494
                            ],
                            [
                                120.386092,
                                28.997306
                            ],
                            [
                                120.390321,
                                29.000912
                            ],
                            [
                                120.393664,
                                29.001968
                            ],
                            [
                                120.394752,
                                29.00518
                            ],
                            [
                                120.394224,
                                29.008451
                            ],
                            [
                                120.395048,
                                29.011605
                            ],
                            [
                                120.397645,
                                29.014075
                            ],
                            [
                                120.403367,
                                29.01796
                            ],
                            [
                                120.406368,
                                29.021635
                            ],
                            [
                                120.408856,
                                29.027468
                            ],
                            [
                                120.404859,
                                29.030088
                            ],
                            [
                                120.404595,
                                29.0317
                            ],
                            [
                                120.406383,
                                29.034413
                            ],
                            [
                                120.411686,
                                29.03956
                            ],
                            [
                                120.412199,
                                29.04385
                            ],
                            [
                                120.407658,
                                29.047722
                            ],
                            [
                                120.406539,
                                29.049414
                            ],
                            [
                                120.408949,
                                29.060948
                            ],
                            [
                                120.410504,
                                29.063011
                            ],
                            [
                                120.41366,
                                29.069548
                            ],
                            [
                                120.417034,
                                29.072086
                            ],
                            [
                                120.422508,
                                29.073697
                            ],
                            [
                                120.42823,
                                29.076131
                            ],
                            [
                                120.437342,
                                29.078333
                            ],
                            [
                                120.443872,
                                29.077846
                            ],
                            [
                                120.448319,
                                29.078298
                            ],
                            [
                                120.451429,
                                29.080905
                            ],
                            [
                                120.453109,
                                29.087476
                            ],
                            [
                                120.454353,
                                29.088461
                            ],
                            [
                                120.46177,
                                29.089782
                            ],
                            [
                                120.465159,
                                29.089376
                            ],
                            [
                                120.473447,
                                29.085042
                            ],
                            [
                                120.479636,
                                29.085089
                            ],
                            [
                                120.480242,
                                29.078031
                            ],
                            [
                                120.483787,
                                29.07525
                            ],
                            [
                                120.483741,
                                29.069119
                            ],
                            [
                                120.486866,
                                29.067995
                            ],
                            [
                                120.49307,
                                29.067137
                            ],
                            [
                                120.494718,
                                29.068597
                            ],
                            [
                                120.496024,
                                29.07219
                            ],
                            [
                                120.492075,
                                29.077799
                            ],
                            [
                                120.493925,
                                29.087766
                            ],
                            [
                                120.490784,
                                29.089724
                            ],
                            [
                                120.49136,
                                29.095738
                            ],
                            [
                                120.494889,
                                29.104578
                            ],
                            [
                                120.49817,
                                29.108738
                            ],
                            [
                                120.49803,
                                29.116395
                            ],
                            [
                                120.492992,
                                29.127458
                            ],
                            [
                                120.48996,
                                29.129149
                            ],
                            [
                                120.477054,
                                29.130574
                            ],
                            [
                                120.47354,
                                29.132497
                            ],
                            [
                                120.471721,
                                29.136122
                            ],
                            [
                                120.471037,
                                29.140222
                            ],
                            [
                                120.473198,
                                29.145781
                            ],
                            [
                                120.475437,
                                29.1487
                            ],
                            [
                                120.478656,
                                29.151329
                            ],
                            [
                                120.49066,
                                29.152093
                            ],
                            [
                                120.500223,
                                29.157107
                            ],
                            [
                                120.506598,
                                29.161867
                            ],
                            [
                                120.511247,
                                29.161959
                            ],
                            [
                                120.51571,
                                29.160871
                            ],
                            [
                                120.521992,
                                29.155579
                            ],
                            [
                                120.530264,
                                29.155509
                            ],
                            [
                                120.537681,
                                29.156447
                            ],
                            [
                                120.54205,
                                29.158798
                            ],
                            [
                                120.551768,
                                29.168258
                            ],
                            [
                                120.553214,
                                29.170759
                            ],
                            [
                                120.554785,
                                29.176051
                            ],
                            [
                                120.559403,
                                29.182071
                            ],
                            [
                                120.55945,
                                29.186713
                            ],
                            [
                                120.56301,
                                29.19124
                            ],
                            [
                                120.569168,
                                29.193393
                            ],
                            [
                                120.579057,
                                29.197502
                            ],
                            [
                                120.587252,
                                29.201496
                            ],
                            [
                                120.593658,
                                29.207017
                            ],
                            [
                                120.600468,
                                29.21594
                            ],
                            [
                                120.602505,
                                29.223104
                            ],
                            [
                                120.601028,
                                29.228254
                            ],
                            [
                                120.601946,
                                29.229527
                            ],
                            [
                                120.605973,
                                29.23051
                            ],
                            [
                                120.616142,
                                29.235579
                            ],
                            [
                                120.619703,
                                29.236123
                            ],
                            [
                                120.626482,
                                29.235961
                            ],
                            [
                                120.630649,
                                29.238541
                            ],
                            [
                                120.633231,
                                29.242984
                            ],
                            [
                                120.632951,
                                29.246895
                            ],
                            [
                                120.636496,
                                29.250123
                            ],
                            [
                                120.640041,
                                29.254588
                            ],
                            [
                                120.64455,
                                29.259066
                            ],
                            [
                                120.644364,
                                29.261148
                            ],
                            [
                                120.650444,
                                29.26574
                            ],
                            [
                                120.65276,
                                29.268181
                            ],
                            [
                                120.657332,
                                29.271432
                            ],
                            [
                                120.664951,
                                29.275931
                            ],
                            [
                                120.668496,
                                29.276521
                            ],
                            [
                                120.672352,
                                29.276197
                            ],
                            [
                                120.677437,
                                29.274127
                            ],
                            [
                                120.681713,
                                29.270391
                            ],
                            [
                                120.687342,
                                29.269789
                            ],
                            [
                                120.68927,
                                29.266435
                            ],
                            [
                                120.68658,
                                29.264653
                            ],
                            [
                                120.689348,
                                29.260604
                            ],
                            [
                                120.690312,
                                29.262201
                            ],
                            [
                                120.693748,
                                29.261426
                            ],
                            [
                                120.695925,
                                29.262374
                            ],
                            [
                                120.696469,
                                29.264977
                            ],
                            [
                                120.701818,
                                29.263068
                            ],
                            [
                                120.706949,
                                29.2591
                            ],
                            [
                                120.709717,
                                29.259008
                            ],
                            [
                                120.717119,
                                29.262467
                            ],
                            [
                                120.719249,
                                29.265717
                            ],
                            [
                                120.71886,
                                29.269673
                            ],
                            [
                                120.720275,
                                29.274948
                            ],
                            [
                                120.722436,
                                29.278048
                            ],
                            [
                                120.728905,
                                29.283507
                            ],
                            [
                                120.731906,
                                29.291476
                            ],
                            [
                                120.737053,
                                29.300542
                            ],
                            [
                                120.734689,
                                29.306451
                            ],
                            [
                                120.72906,
                                29.310163
                            ],
                            [
                                120.725935,
                                29.310244
                            ],
                            [
                                120.722965,
                                29.308128
                            ],
                            [
                                120.720431,
                                29.303202
                            ],
                            [
                                120.717227,
                                29.301618
                            ],
                            [
                                120.711505,
                                29.302115
                            ],
                            [
                                120.708613,
                                29.305098
                            ],
                            [
                                120.706312,
                                29.310625
                            ],
                            [
                                120.703529,
                                29.315007
                            ],
                            [
                                120.699859,
                                29.318858
                            ],
                            [
                                120.69975,
                                29.321621
                            ],
                            [
                                120.701787,
                                29.324083
                            ],
                            [
                                120.705908,
                                29.332823
                            ],
                            [
                                120.707851,
                                29.341308
                            ],
                            [
                                120.707462,
                                29.346914
                            ],
                            [
                                120.704679,
                                29.347585
                            ],
                            [
                                120.697418,
                                29.34184
                            ],
                            [
                                120.694215,
                                29.341424
                            ],
                            [
                                120.687948,
                                29.341863
                            ],
                            [
                                120.684916,
                                29.338939
                            ],
                            [
                                120.67935,
                                29.334673
                            ],
                            [
                                120.673596,
                                29.328188
                            ],
                            [
                                120.670207,
                                29.325529
                            ],
                            [
                                120.660286,
                                29.33043
                            ],
                            [
                                120.653662,
                                29.334303
                            ],
                            [
                                120.650381,
                                29.334002
                            ],
                            [
                                120.645748,
                                29.328419
                            ],
                            [
                                120.643851,
                                29.328188
                            ],
                            [
                                120.641223,
                                29.330766
                            ],
                            [
                                120.631474,
                                29.332858
                            ],
                            [
                                120.624088,
                                29.336338
                            ],
                            [
                                120.621444,
                                29.336442
                            ],
                            [
                                120.616142,
                                29.335286
                            ],
                            [
                                120.61255,
                                29.333621
                            ],
                            [
                                120.60731,
                                29.335158
                            ],
                            [
                                120.600982,
                                29.334164
                            ],
                            [
                                120.59697,
                                29.341424
                            ],
                            [
                                120.593036,
                                29.346625
                            ],
                            [
                                120.590999,
                                29.348475
                            ],
                            [
                                120.58621,
                                29.348983
                            ],
                            [
                                120.583629,
                                29.347088
                            ],
                            [
                                120.579135,
                                29.340094
                            ],
                            [
                                120.573973,
                                29.339967
                            ],
                            [
                                120.571531,
                                29.342649
                            ],
                            [
                                120.572573,
                                29.347018
                            ],
                            [
                                120.575077,
                                29.349781
                            ],
                            [
                                120.578497,
                                29.356427
                            ],
                            [
                                120.577067,
                                29.358692
                            ],
                            [
                                120.570583,
                                29.363396
                            ],
                            [
                                120.566696,
                                29.367302
                            ],
                            [
                                120.563617,
                                29.367417
                            ],
                            [
                                120.559201,
                                29.366238
                            ],
                            [
                                120.55648,
                                29.367487
                            ],
                            [
                                120.553774,
                                29.371473
                            ],
                            [
                                120.559372,
                                29.377448
                            ],
                            [
                                120.559481,
                                29.379608
                            ],
                            [
                                120.552779,
                                29.387408
                            ],
                            [
                                120.550509,
                                29.390943
                            ],
                            [
                                120.548534,
                                29.391417
                            ],
                            [
                                120.542392,
                                29.389845
                            ],
                            [
                                120.53779,
                                29.391925
                            ],
                            [
                                120.530808,
                                29.399215
                            ],
                            [
                                120.524122,
                                29.401133
                            ],
                            [
                                120.522785,
                                29.403166
                            ],
                            [
                                120.519177,
                                29.411195
                            ],
                            [
                                120.513875,
                                29.415561
                            ],
                            [
                                120.511154,
                                29.41943
                            ],
                            [
                                120.511682,
                                29.426765
                            ],
                            [
                                120.511076,
                                29.431373
                            ],
                            [
                                120.511838,
                                29.4403
                            ],
                            [
                                120.514792,
                                29.450311
                            ],
                            [
                                120.515896,
                                29.451755
                            ],
                            [
                                120.520001,
                                29.454006
                            ],
                            [
                                120.522178,
                                29.457008
                            ],
                            [
                                120.520235,
                                29.458625
                            ],
                            [
                                120.516969,
                                29.466083
                            ],
                            [
                                120.515243,
                                29.468554
                            ],
                            [
                                120.512647,
                                29.469223
                            ],
                            [
                                120.506256,
                                29.468623
                            ],
                            [
                                120.503239,
                                29.469443
                            ],
                            [
                                120.497766,
                                29.46651
                            ],
                            [
                                120.496444,
                                29.466787
                            ],
                            [
                                120.497735,
                                29.471024
                            ],
                            [
                                120.497766,
                                29.474349
                            ],
                            [
                                120.493848,
                                29.477962
                            ],
                            [
                                120.481999,
                                29.484854
                            ],
                            [
                                120.474862,
                                29.492876
                            ],
                            [
                                120.469902,
                                29.495207
                            ],
                            [
                                120.469233,
                                29.490925
                            ],
                            [
                                120.46404,
                                29.48924
                            ],
                            [
                                120.461443,
                                29.484946
                            ],
                            [
                                120.453264,
                                29.482799
                            ],
                            [
                                120.445039,
                                29.479625
                            ],
                            [
                                120.440794,
                                29.479625
                            ],
                            [
                                120.437326,
                                29.47862
                            ],
                            [
                                120.433112,
                                29.479648
                            ],
                            [
                                120.427779,
                                29.477224
                            ],
                            [
                                120.425415,
                                29.474592
                            ],
                            [
                                120.422725,
                                29.469235
                            ],
                            [
                                120.417206,
                                29.460518
                            ],
                            [
                                120.412992,
                                29.451974
                            ],
                            [
                                120.410395,
                                29.450646
                            ],
                            [
                                120.402325,
                                29.453025
                            ],
                            [
                                120.39878,
                                29.455565
                            ],
                            [
                                120.3927,
                                29.455276
                            ],
                            [
                                120.387849,
                                29.456593
                            ],
                            [
                                120.383992,
                                29.456154
                            ],
                            [
                                120.379545,
                                29.452621
                            ],
                            [
                                120.376187,
                                29.449145
                            ],
                            [
                                120.370807,
                                29.447944
                            ],
                            [
                                120.367324,
                                29.445554
                            ],
                            [
                                120.364432,
                                29.433879
                            ],
                            [
                                120.366111,
                                29.431604
                            ],
                            [
                                120.369983,
                                29.428647
                            ],
                            [
                                120.373668,
                                29.417536
                            ],
                            [
                                120.372828,
                                29.414914
                            ],
                            [
                                120.367448,
                                29.415572
                            ],
                            [
                                120.363032,
                                29.415307
                            ],
                            [
                                120.357434,
                                29.413389
                            ],
                            [
                                120.343673,
                                29.410224
                            ],
                            [
                                120.340703,
                                29.40625
                            ],
                            [
                                120.334064,
                                29.403212
                            ],
                            [
                                120.333442,
                                29.401168
                            ],
                            [
                                120.333286,
                                29.395149
                            ],
                            [
                                120.330441,
                                29.389118
                            ],
                            [
                                120.327269,
                                29.384519
                            ],
                            [
                                120.325325,
                                29.380637
                            ],
                            [
                                120.317271,
                                29.379701
                            ],
                            [
                                120.312575,
                                29.374859
                            ],
                            [
                                120.308423,
                                29.366377
                            ],
                            [
                                120.306604,
                                29.365164
                            ],
                            [
                                120.30068,
                                29.3635
                            ],
                            [
                                120.29631,
                                29.361477
                            ],
                            [
                                120.299032,
                                29.356646
                            ],
                            [
                                120.2953,
                                29.354808
                            ],
                            [
                                120.292112,
                                29.354577
                            ],
                            [
                                120.28992,
                                29.355583
                            ],
                            [
                                120.287836,
                                29.359339
                            ],
                            [
                                120.283731,
                                29.361916
                            ],
                            [
                                120.278289,
                                29.363453
                            ],
                            [
                                120.274697,
                                29.366065
                            ],
                            [
                                120.271509,
                                29.369324
                            ],
                            [
                                120.26672,
                                29.376558
                            ],
                            [
                                120.26599,
                                29.383202
                            ],
                            [
                                120.261356,
                                29.390342
                            ],
                            [
                                120.261325,
                                29.39464
                            ],
                            [
                                120.26403,
                                29.400833
                            ],
                            [
                                120.25568,
                                29.402369
                            ],
                            [
                                120.251731,
                                29.402612
                            ],
                            [
                                120.248668,
                                29.401179
                            ],
                            [
                                120.247828,
                                29.397378
                            ],
                            [
                                120.25002,
                                29.393219
                            ],
                            [
                                120.248668,
                                29.39092
                            ],
                            [
                                120.247673,
                                29.385755
                            ],
                            [
                                120.24548,
                                29.379839
                            ],
                            [
                                120.242619,
                                29.37442
                            ],
                            [
                                120.240629,
                                29.372259
                            ],
                            [
                                120.240007,
                                29.368596
                            ],
                            [
                                120.238063,
                                29.366527
                            ],
                            [
                                120.234673,
                                29.364678
                            ],
                            [
                                120.234502,
                                29.36135
                            ],
                            [
                                120.236539,
                                29.359351
                            ],
                            [
                                120.237084,
                                29.355409
                            ],
                            [
                                120.236446,
                                29.343932
                            ],
                            [
                                120.230133,
                                29.339667
                            ],
                            [
                                120.225966,
                                29.336222
                            ],
                            [
                                120.219637,
                                29.331841
                            ],
                            [
                                120.217056,
                                29.327875
                            ],
                            [
                                120.209219,
                                29.326997
                            ],
                            [
                                120.206498,
                                29.325205
                            ],
                            [
                                120.202347,
                                29.31362
                            ],
                            [
                                120.199579,
                                29.311666
                            ],
                            [
                                120.198677,
                                29.313493
                            ],
                            [
                                120.196609,
                                29.309897
                            ],
                            [
                                120.197029,
                                29.306289
                            ],
                            [
                                120.195427,
                                29.302913
                            ],
                            [
                                120.191213,
                                29.303421
                            ],
                            [
                                120.188057,
                                29.305133
                            ],
                            [
                                120.185134,
                                29.304774
                            ],
                            [
                                120.175882,
                                29.305295
                            ],
                            [
                                120.170533,
                                29.306324
                            ],
                            [
                                120.167703,
                                29.309446
                            ],
                            [
                                120.165635,
                                29.308671
                            ],
                            [
                                120.162603,
                                29.303236
                            ],
                            [
                                120.160924,
                                29.301398
                            ],
                            [
                                120.157332,
                                29.301386
                            ],
                            [
                                120.156088,
                                29.294332
                            ],
                            [
                                120.155124,
                                29.291823
                            ],
                            [
                                120.148515,
                                29.286861
                            ],
                            [
                                120.146261,
                                29.283125
                            ],
                            [
                                120.14738,
                                29.281402
                            ],
                            [
                                120.155855,
                                29.276567
                            ],
                            [
                                120.157829,
                                29.272681
                            ],
                            [
                                120.155046,
                                29.269338
                            ],
                            [
                                120.156476,
                                29.265926
                            ],
                            [
                                120.155015,
                                29.262941
                            ],
                            [
                                120.15573,
                                29.260928
                            ],
                            [
                                120.158296,
                                29.259517
                            ],
                            [
                                120.163925,
                                29.254507
                            ],
                            [
                                120.164438,
                                29.251592
                            ],
                            [
                                120.161266,
                                29.247369
                            ],
                            [
                                120.157891,
                                29.245853
                            ],
                            [
                                120.151143,
                                29.238842
                            ],
                            [
                                120.14469,
                                29.239733
                            ],
                            [
                                120.143882,
                                29.242313
                            ],
                            [
                                120.142404,
                                29.242822
                            ],
                            [
                                120.135454,
                                29.239929
                            ],
                            [
                                120.133215,
                                29.239941
                            ],
                            [
                                120.1325,
                                29.238425
                            ],
                            [
                                120.136449,
                                29.234491
                            ],
                            [
                                120.131567,
                                29.228289
                            ],
                            [
                                120.127928,
                                29.226506
                            ],
                            [
                                120.122533,
                                29.216959
                            ],
                            [
                                120.119361,
                                29.212827
                            ],
                            [
                                120.113079,
                                29.207353
                            ],
                            [
                                120.105739,
                                29.204216
                            ],
                            [
                                120.10591,
                                29.199459
                            ],
                            [
                                120.107823,
                                29.195465
                            ],
                            [
                                120.104884,
                                29.188184
                            ],
                            [
                                120.094171,
                                29.181944
                            ],
                            [
                                120.091901,
                                29.179894
                            ],
                            [
                                120.091527,
                                29.177718
                            ],
                            [
                                120.092694,
                                29.17194
                            ],
                            [
                                120.09414,
                                29.170516
                            ],
                            [
                                120.08991,
                                29.167043
                            ],
                            [
                                120.091574,
                                29.162029
                            ],
                            [
                                120.090859,
                                29.159898
                            ],
                            [
                                120.087376,
                                29.157628
                            ],
                            [
                                120.08649,
                                29.155359
                            ],
                            [
                                120.086085,
                                29.149719
                            ],
                            [
                                120.084981,
                                29.144403
                            ],
                            [
                                120.08467,
                                29.137964
                            ],
                            [
                                120.085277,
                                29.136249
                            ],
                            [
                                120.089646,
                                29.131616
                            ],
                            [
                                120.091123,
                                29.129172
                            ],
                            [
                                120.093082,
                                29.121794
                            ],
                            [
                                120.092865,
                                29.115955
                            ],
                            [
                                120.091325,
                                29.112966
                            ],
                            [
                                120.086645,
                                29.110649
                            ],
                            [
                                120.084017,
                                29.106108
                            ],
                            [
                                120.084017,
                                29.104845
                            ],
                            [
                                120.08722,
                                29.098484
                            ],
                            [
                                120.086225,
                                29.09707
                            ],
                            [
                                120.081887,
                                29.098611
                            ],
                            [
                                120.077067,
                                29.098067
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 330784,
                "name": "永康市",
                "center": [
                    120.036328,
                    28.895293
                ],
                "centroid": [
                    120.102417,
                    28.934317
                ],
                "childrenNum": 0,
                "level": "district",
                "parent": {
                    "adcode": 330700
                },
                "subFeatureIndex": 8,
                "acroutes": [
                    100000,
                    330000,
                    330700
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                120.077067,
                                29.098067
                            ],
                            [
                                120.074781,
                                29.099225
                            ],
                            [
                                120.073039,
                                29.101867
                            ],
                            [
                                120.070925,
                                29.100488
                            ],
                            [
                                120.072215,
                                29.094185
                            ],
                            [
                                120.068997,
                                29.087499
                            ],
                            [
                                120.066058,
                                29.085274
                            ],
                            [
                                120.065731,
                                29.082458
                            ],
                            [
                                120.063632,
                                29.080847
                            ],
                            [
                                120.06357,
                                29.078078
                            ],
                            [
                                120.062186,
                                29.076641
                            ],
                            [
                                120.060071,
                                29.077753
                            ],
                            [
                                120.058019,
                                29.074485
                            ],
                            [
                                120.058516,
                                29.072909
                            ],
                            [
                                120.062948,
                                29.070382
                            ],
                            [
                                120.059325,
                                29.068018
                            ],
                            [
                                120.056697,
                                29.068783
                            ],
                            [
                                120.050058,
                                29.068319
                            ],
                            [
                                120.042672,
                                29.065619
                            ],
                            [
                                120.035519,
                                29.061643
                            ],
                            [
                                120.032674,
                                29.061168
                            ],
                            [
                                120.024868,
                                29.064645
                            ],
                            [
                                120.020608,
                                29.061562
                            ],
                            [
                                120.01204,
                                29.057343
                            ],
                            [
                                120.005354,
                                29.054897
                            ],
                            [
                                120.000844,
                                29.055639
                            ],
                            [
                                119.996631,
                                29.052799
                            ],
                            [
                                119.991919,
                                29.051605
                            ],
                            [
                                119.990131,
                                29.050179
                            ],
                            [
                                119.985668,
                                29.039525
                            ],
                            [
                                119.983087,
                                29.034958
                            ],
                            [
                                119.978765,
                                29.034227
                            ],
                            [
                                119.97113,
                                29.043502
                            ],
                            [
                                119.961909,
                                29.050643
                            ],
                            [
                                119.955208,
                                29.053831
                            ],
                            [
                                119.951585,
                                29.057969
                            ],
                            [
                                119.947106,
                                29.060681
                            ],
                            [
                                119.93941,
                                29.061353
                            ],
                            [
                                119.935071,
                                29.059255
                            ],
                            [
                                119.930795,
                                29.054515
                            ],
                            [
                                119.928961,
                                29.053726
                            ],
                            [
                                119.918543,
                                29.05579
                            ],
                            [
                                119.911297,
                                29.053541
                            ],
                            [
                                119.907503,
                                29.050991
                            ],
                            [
                                119.905061,
                                29.04647
                            ],
                            [
                                119.909819,
                                29.047872
                            ],
                            [
                                119.914049,
                                29.046817
                            ],
                            [
                                119.918698,
                                29.041519
                            ],
                            [
                                119.911063,
                                29.031352
                            ],
                            [
                                119.908902,
                                29.029474
                            ],
                            [
                                119.904066,
                                29.027039
                            ],
                            [
                                119.900148,
                                29.026842
                            ],
                            [
                                119.896012,
                                29.023595
                            ],
                            [
                                119.895872,
                                29.021821
                            ],
                            [
                                119.897333,
                                29.014179
                            ],
                            [
                                119.895607,
                                29.011106
                            ],
                            [
                                119.897085,
                                29.008915
                            ],
                            [
                                119.898624,
                                28.996969
                            ],
                            [
                                119.895359,
                                28.992527
                            ],
                            [
                                119.899324,
                                28.990277
                            ],
                            [
                                119.901501,
                                28.99291
                            ],
                            [
                                119.907658,
                                28.994789
                            ],
                            [
                                119.909166,
                                28.993698
                            ],
                            [
                                119.910379,
                                28.995995
                            ],
                            [
                                119.906818,
                                28.996958
                            ],
                            [
                                119.909711,
                                28.998744
                            ],
                            [
                                119.916164,
                                28.999625
                            ],
                            [
                                119.922041,
                                29.000959
                            ],
                            [
                                119.926193,
                                28.999161
                            ],
                            [
                                119.929707,
                                28.994
                            ],
                            [
                                119.930173,
                                28.991993
                            ],
                            [
                                119.928961,
                                28.988027
                            ],
                            [
                                119.931448,
                                28.9845
                            ],
                            [
                                119.933967,
                                28.982877
                            ],
                            [
                                119.941307,
                                28.982134
                            ],
                            [
                                119.942706,
                                28.980731
                            ],
                            [
                                119.942768,
                                28.978097
                            ],
                            [
                                119.940094,
                                28.970673
                            ],
                            [
                                119.936782,
                                28.967413
                            ],
                            [
                                119.931433,
                                28.967668
                            ],
                            [
                                119.927048,
                                28.962912
                            ],
                            [
                                119.925322,
                                28.954871
                            ],
                            [
                                119.923285,
                                28.952098
                            ],
                            [
                                119.919569,
                                28.949789
                            ],
                            [
                                119.916381,
                                28.948988
                            ],
                            [
                                119.910317,
                                28.946087
                            ],
                            [
                                119.903849,
                                28.947584
                            ],
                            [
                                119.901703,
                                28.945739
                            ],
                            [
                                119.902838,
                                28.942421
                            ],
                            [
                                119.90671,
                                28.938521
                            ],
                            [
                                119.910923,
                                28.931466
                            ],
                            [
                                119.918838,
                                28.928355
                            ],
                            [
                                119.922352,
                                28.92615
                            ],
                            [
                                119.921373,
                                28.919279
                            ],
                            [
                                119.918947,
                                28.912675
                            ],
                            [
                                119.919429,
                                28.910609
                            ],
                            [
                                119.923472,
                                28.907068
                            ],
                            [
                                119.924933,
                                28.903574
                            ],
                            [
                                119.924467,
                                28.897189
                            ],
                            [
                                119.927996,
                                28.89626
                            ],
                            [
                                119.93759,
                                28.895866
                            ],
                            [
                                119.940032,
                                28.893729
                            ],
                            [
                                119.93955,
                                28.890293
                            ],
                            [
                                119.940529,
                                28.887959
                            ],
                            [
                                119.944463,
                                28.883013
                            ],
                            [
                                119.950387,
                                28.877823
                            ],
                            [
                                119.951989,
                                28.875675
                            ],
                            [
                                119.958706,
                                28.870264
                            ],
                            [
                                119.961163,
                                28.870705
                            ],
                            [
                                119.966885,
                                28.868615
                            ],
                            [
                                119.969171,
                                28.864155
                            ],
                            [
                                119.971472,
                                28.855933
                            ],
                            [
                                119.973447,
                                28.851136
                            ],
                            [
                                119.973089,
                                28.849139
                            ],
                            [
                                119.970741,
                                28.845863
                            ],
                            [
                                119.967834,
                                28.843877
                            ],
                            [
                                119.965455,
                                28.839196
                            ],
                            [
                                119.968129,
                                28.833318
                            ],
                            [
                                119.974908,
                                28.823351
                            ],
                            [
                                119.974566,
                                28.818832
                            ],
                            [
                                119.971892,
                                28.815881
                            ],
                            [
                                119.969373,
                                28.811152
                            ],
                            [
                                119.959966,
                                28.807887
                            ],
                            [
                                119.957213,
                                28.807515
                            ],
                            [
                                119.94608,
                                28.808619
                            ],
                            [
                                119.940187,
                                28.806458
                            ],
                            [
                                119.931153,
                                28.804064
                            ],
                            [
                                119.929163,
                                28.80188
                            ],
                            [
                                119.932319,
                                28.795837
                            ],
                            [
                                119.936253,
                                28.79335
                            ],
                            [
                                119.941618,
                                28.793071
                            ],
                            [
                                119.946624,
                                28.790224
                            ],
                            [
                                119.948692,
                                28.787156
                            ],
                            [
                                119.95258,
                                28.787191
                            ],
                            [
                                119.958426,
                                28.789039
                            ],
                            [
                                119.963324,
                                28.786982
                            ],
                            [
                                119.9676,
                                28.787807
                            ],
                            [
                                119.970524,
                                28.791154
                            ],
                            [
                                119.971628,
                                28.794257
                            ],
                            [
                                119.973431,
                                28.795128
                            ],
                            [
                                119.977707,
                                28.795082
                            ],
                            [
                                119.982419,
                                28.796651
                            ],
                            [
                                119.982621,
                                28.793606
                            ],
                            [
                                119.984456,
                                28.791154
                            ],
                            [
                                119.99223,
                                28.789236
                            ],
                            [
                                119.996584,
                                28.785494
                            ],
                            [
                                120.003892,
                                28.782217
                            ],
                            [
                                120.005323,
                                28.780904
                            ],
                            [
                                120.009443,
                                28.781589
                            ],
                            [
                                120.011247,
                                28.777835
                            ],
                            [
                                120.010158,
                                28.774953
                            ],
                            [
                                120.010687,
                                28.772233
                            ],
                            [
                                120.016363,
                                28.769839
                            ],
                            [
                                120.021369,
                                28.76584
                            ],
                            [
                                120.025677,
                                28.764155
                            ],
                            [
                                120.028957,
                                28.758063
                            ],
                            [
                                120.037276,
                                28.761039
                            ],
                            [
                                120.049187,
                                28.763143
                            ],
                            [
                                120.058656,
                                28.769792
                            ],
                            [
                                120.069043,
                                28.778277
                            ],
                            [
                                120.072604,
                                28.779707
                            ],
                            [
                                120.075776,
                                28.782624
                            ],
                            [
                                120.083955,
                                28.78704
                            ],
                            [
                                120.088278,
                                28.787377
                            ],
                            [
                                120.09075,
                                28.786122
                            ],
                            [
                                120.088635,
                                28.7788
                            ],
                            [
                                120.091901,
                                28.775174
                            ],
                            [
                                120.092181,
                                28.773581
                            ],
                            [
                                120.097032,
                                28.768572
                            ],
                            [
                                120.100095,
                                28.768641
                            ],
                            [
                                120.105382,
                                28.767619
                            ],
                            [
                                120.107761,
                                28.768362
                            ],
                            [
                                120.109876,
                                28.767235
                            ],
                            [
                                120.109658,
                                28.763643
                            ],
                            [
                                120.111322,
                                28.762306
                            ],
                            [
                                120.117868,
                                28.762748
                            ],
                            [
                                120.120185,
                                28.760505
                            ],
                            [
                                120.125984,
                                28.759354
                            ],
                            [
                                120.131411,
                                28.759726
                            ],
                            [
                                120.136138,
                                28.764375
                            ],
                            [
                                120.138626,
                                28.76906
                            ],
                            [
                                120.141129,
                                28.776045
                            ],
                            [
                                120.137538,
                                28.779509
                            ],
                            [
                                120.138066,
                                28.782031
                            ],
                            [
                                120.145576,
                                28.783995
                            ],
                            [
                                120.153336,
                                28.780137
                            ],
                            [
                                120.158762,
                                28.779509
                            ],
                            [
                                120.164407,
                                28.776545
                            ],
                            [
                                120.16534,
                                28.774337
                            ],
                            [
                                120.175493,
                                28.773686
                            ],
                            [
                                120.178432,
                                28.775243
                            ],
                            [
                                120.18036,
                                28.779799
                            ],
                            [
                                120.182366,
                                28.781427
                            ],
                            [
                                120.181899,
                                28.783112
                            ],
                            [
                                120.183579,
                                28.785157
                            ],
                            [
                                120.190296,
                                28.785308
                            ],
                            [
                                120.195038,
                                28.783937
                            ],
                            [
                                120.198832,
                                28.783972
                            ],
                            [
                                120.202269,
                                28.785796
                            ],
                            [
                                120.206249,
                                28.78912
                            ],
                            [
                                120.209375,
                                28.793687
                            ],
                            [
                                120.209359,
                                28.795849
                            ],
                            [
                                120.20611,
                                28.797615
                            ],
                            [
                                120.200341,
                                28.801822
                            ],
                            [
                                120.200092,
                                28.804587
                            ],
                            [
                                120.20188,
                                28.810025
                            ],
                            [
                                120.206218,
                                28.816055
                            ],
                            [
                                120.21278,
                                28.822538
                            ],
                            [
                                120.215128,
                                28.825872
                            ],
                            [
                                120.216496,
                                28.83261
                            ],
                            [
                                120.217896,
                                28.83376
                            ],
                            [
                                120.227536,
                                28.8375
                            ],
                            [
                                120.232885,
                                28.841392
                            ],
                            [
                                120.236508,
                                28.844818
                            ],
                            [
                                120.238172,
                                28.848465
                            ],
                            [
                                120.238934,
                                28.852542
                            ],
                            [
                                120.241826,
                                28.857269
                            ],
                            [
                                120.244578,
                                28.860277
                            ],
                            [
                                120.247082,
                                28.861624
                            ],
                            [
                                120.254436,
                                28.863215
                            ],
                            [
                                120.260703,
                                28.865491
                            ],
                            [
                                120.262009,
                                28.868975
                            ],
                            [
                                120.260858,
                                28.880331
                            ],
                            [
                                120.261776,
                                28.888969
                            ],
                            [
                                120.26134,
                                28.899523
                            ],
                            [
                                120.258977,
                                28.903736
                            ],
                            [
                                120.259163,
                                28.905605
                            ],
                            [
                                120.2626,
                                28.909808
                            ],
                            [
                                120.261776,
                                28.911421
                            ],
                            [
                                120.255261,
                                28.911154
                            ],
                            [
                                120.252011,
                                28.912187
                            ],
                            [
                                120.250751,
                                28.913801
                            ],
                            [
                                120.254265,
                                28.919384
                            ],
                            [
                                120.255836,
                                28.922877
                            ],
                            [
                                120.258293,
                                28.924955
                            ],
                            [
                                120.258619,
                                28.927113
                            ],
                            [
                                120.255463,
                                28.93099
                            ],
                            [
                                120.255525,
                                28.93244
                            ],
                            [
                                120.25879,
                                28.936746
                            ],
                            [
                                120.262475,
                                28.937036
                            ],
                            [
                                120.264979,
                                28.938951
                            ],
                            [
                                120.265383,
                                28.940889
                            ],
                            [
                                120.26375,
                                28.943094
                            ],
                            [
                                120.270981,
                                28.950114
                            ],
                            [
                                120.272676,
                                28.948907
                            ],
                            [
                                120.275335,
                                28.942432
                            ],
                            [
                                120.275646,
                                28.938313
                            ],
                            [
                                120.27776,
                                28.935667
                            ],
                            [
                                120.276983,
                                28.93222
                            ],
                            [
                                120.277869,
                                28.930549
                            ],
                            [
                                120.280777,
                                28.930526
                            ],
                            [
                                120.289858,
                                28.932684
                            ],
                            [
                                120.297135,
                                28.932011
                            ],
                            [
                                120.302001,
                                28.933322
                            ],
                            [
                                120.303976,
                                28.931651
                            ],
                            [
                                120.307941,
                                28.933833
                            ],
                            [
                                120.310631,
                                28.939253
                            ],
                            [
                                120.312451,
                                28.941585
                            ],
                            [
                                120.315965,
                                28.943917
                            ],
                            [
                                120.316416,
                                28.946308
                            ],
                            [
                                120.322418,
                                28.951112
                            ],
                            [
                                120.328964,
                                28.95544
                            ],
                            [
                                120.33394,
                                28.957865
                            ],
                            [
                                120.342336,
                                28.961194
                            ],
                            [
                                120.347141,
                                28.961148
                            ],
                            [
                                120.348696,
                                28.962633
                            ],
                            [
                                120.346099,
                                28.965522
                            ],
                            [
                                120.349364,
                                28.971961
                            ],
                            [
                                120.348525,
                                28.979884
                            ],
                            [
                                120.347467,
                                28.982552
                            ],
                            [
                                120.345415,
                                28.982123
                            ],
                            [
                                120.343129,
                                28.978689
                            ],
                            [
                                120.340937,
                                28.977726
                            ],
                            [
                                120.339584,
                                28.974211
                            ],
                            [
                                120.330612,
                                28.967274
                            ],
                            [
                                120.328902,
                                28.96681
                            ],
                            [
                                120.324486,
                                28.968921
                            ],
                            [
                                120.322464,
                                28.971404
                            ],
                            [
                                120.321593,
                                28.974756
                            ],
                            [
                                120.322713,
                                28.979014
                            ],
                            [
                                120.326429,
                                28.981438
                            ],
                            [
                                120.325636,
                                28.984245
                            ],
                            [
                                120.322169,
                                28.98486
                            ],
                            [
                                120.321889,
                                28.986878
                            ],
                            [
                                120.317768,
                                28.988398
                            ],
                            [
                                120.313788,
                                28.994452
                            ],
                            [
                                120.316245,
                                28.996807
                            ],
                            [
                                120.318484,
                                28.997201
                            ],
                            [
                                120.322122,
                                29.003023
                            ],
                            [
                                120.322184,
                                29.006711
                            ],
                            [
                                120.319681,
                                29.009796
                            ],
                            [
                                120.312062,
                                29.009634
                            ],
                            [
                                120.309247,
                                29.01048
                            ],
                            [
                                120.306946,
                                29.008926
                            ],
                            [
                                120.299374,
                                29.010828
                            ],
                            [
                                120.295409,
                                29.011014
                            ],
                            [
                                120.290464,
                                29.009123
                            ],
                            [
                                120.287789,
                                29.008868
                            ],
                            [
                                120.285768,
                                29.009947
                            ],
                            [
                                120.280248,
                                29.015084
                            ],
                            [
                                120.278118,
                                29.018041
                            ],
                            [
                                120.276734,
                                29.023954
                            ],
                            [
                                120.274837,
                                29.025485
                            ],
                            [
                                120.266814,
                                29.026934
                            ],
                            [
                                120.261574,
                                29.025902
                            ],
                            [
                                120.257515,
                                29.026726
                            ],
                            [
                                120.246071,
                                29.031375
                            ],
                            [
                                120.243754,
                                29.033474
                            ],
                            [
                                120.241671,
                                29.039096
                            ],
                            [
                                120.240038,
                                29.048313
                            ],
                            [
                                120.242153,
                                29.053309
                            ],
                            [
                                120.238887,
                                29.054572
                            ],
                            [
                                120.235498,
                                29.061006
                            ],
                            [
                                120.228096,
                                29.062756
                            ],
                            [
                                120.220073,
                                29.06636
                            ],
                            [
                                120.215579,
                                29.065642
                            ],
                            [
                                120.21009,
                                29.066615
                            ],
                            [
                                120.206871,
                                29.065677
                            ],
                            [
                                120.203637,
                                29.062686
                            ],
                            [
                                120.197791,
                                29.060612
                            ],
                            [
                                120.191416,
                                29.062002
                            ],
                            [
                                120.184496,
                                29.066697
                            ],
                            [
                                120.180655,
                                29.066685
                            ],
                            [
                                120.173223,
                                29.068725
                            ],
                            [
                                120.170564,
                                29.070579
                            ],
                            [
                                120.171559,
                                29.073465
                            ],
                            [
                                120.167376,
                                29.074705
                            ],
                            [
                                120.164158,
                                29.077533
                            ],
                            [
                                120.157549,
                                29.074844
                            ],
                            [
                                120.15772,
                                29.076733
                            ],
                            [
                                120.168356,
                                29.085181
                            ],
                            [
                                120.174203,
                                29.089353
                            ],
                            [
                                120.1754,
                                29.091427
                            ],
                            [
                                120.173705,
                                29.093571
                            ],
                            [
                                120.172492,
                                29.093049
                            ],
                            [
                                120.16775,
                                29.088171
                            ],
                            [
                                120.163785,
                                29.088287
                            ],
                            [
                                120.159415,
                                29.091543
                            ],
                            [
                                120.153398,
                                29.091532
                            ],
                            [
                                120.149277,
                                29.094452
                            ],
                            [
                                120.144504,
                                29.094602
                            ],
                            [
                                120.141767,
                                29.09568
                            ],
                            [
                                120.139668,
                                29.095042
                            ],
                            [
                                120.129701,
                                29.086746
                            ],
                            [
                                120.125969,
                                29.0878
                            ],
                            [
                                120.12233,
                                29.0905
                            ],
                            [
                                120.116981,
                                29.095599
                            ],
                            [
                                120.114167,
                                29.101624
                            ],
                            [
                                120.109565,
                                29.099422
                            ],
                            [
                                120.10661,
                                29.096804
                            ],
                            [
                                120.104791,
                                29.092065
                            ],
                            [
                                120.100235,
                                29.08955
                            ],
                            [
                                120.094933,
                                29.091114
                            ],
                            [
                                120.093347,
                                29.093107
                            ],
                            [
                                120.090657,
                                29.092459
                            ],
                            [
                                120.088324,
                                29.094591
                            ],
                            [
                                120.084484,
                                29.093617
                            ],
                            [
                                120.081109,
                                29.097823
                            ],
                            [
                                120.078824,
                                29.096363
                            ],
                            [
                                120.077067,
                                29.098067
                            ]
                        ]
                    ]
                ]
            }
        }
    ]
}